(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[93666,65622,21572,34733],{

/***/ 65923:
/***/ (function() {

"use strict";


/***/ }),

/***/ 74623:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports, "__esModule", ({value: true})); function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { newObj[key] = obj[key]; } } } newObj.default = obj; return newObj; } } function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }var _chunkOL2KRAIPjs = __webpack_require__(42310);var _react = __webpack_require__(67294); var t = _interopRequireWildcard(_react);var _styled = __webpack_require__(95934); var _styled2 = _interopRequireDefault(_styled);var _jsxruntime = __webpack_require__(85893);var m=_styled2.default.p`
  margin: 0;
  color: ${r=>r.$color};
`,h=r=>r==="p1"||r==="p2"||r==="p3"?"p":r,p= exports.a =t.forwardRef((r,e)=>{let y=_chunkOL2KRAIPjs.b.call(void 0, ),{as:s,variant:o,className:n,color:i=y.BASE_FILL,children:l,title:c}=r,g=s||h(o);return _jsxruntime.jsx.call(void 0, m,{className:`${o}_variant aquilla-typography typography ${n||""}`,as:g,ref:e,title:c,$variant:o,$color:i,children:l})});p.displayName="Typography";var $=p;exports.a = p; exports.b = $;


/***/ }),

/***/ 82353:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";
var __webpack_unused_export__;
__webpack_unused_export__ = ({value: true});__webpack_require__(65923);var _chunkMQ5AGG7Cjs = __webpack_require__(74623);__webpack_require__(42310);__webpack_require__(37186);__webpack_unused_export__ = _chunkMQ5AGG7Cjs.a; exports.ZP = _chunkMQ5AGG7Cjs.b;


/***/ }),

/***/ 14293:
/***/ (function(module) {

/**
 * Checks if `value` is `null` or `undefined`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is nullish, else `false`.
 * @example
 *
 * _.isNil(null);
 * // => true
 *
 * _.isNil(void 0);
 * // => true
 *
 * _.isNil(NaN);
 * // => false
 */
function isNil(value) {
  return value == null;
}

module.exports = isNil;


/***/ }),

/***/ 61059:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "E": function() { return /* binding */ getUserModel; },
/* harmony export */   "P": function() { return /* binding */ getFullName; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(69396);
/* harmony import */ var _utils_textHelper__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(31309);



var getFullName = function(firstName, lastName) {
    return "".concat((0,_utils_textHelper__WEBPACK_IMPORTED_MODULE_0__/* .capitalize */ .kC)(firstName), " ").concat((0,_utils_textHelper__WEBPACK_IMPORTED_MODULE_0__/* .capitalize */ .kC)(lastName));
};
var getUserModel = function() {
    var user = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    return (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)({}, user), {
        description: user.bio || null,
        thumbnail: user.avatarV1 || user.avatar || null,
        liveMinutes: user.liveMinutes ? Math.round(user.liveMinutes / 60) : 0,
        totalWatchMins: user.totalWatchTime ? Math.round(user.totalWatchTime / 60) : 0,
        name: getFullName(user.firstName, user.lastName),
        newEducatorAvatar: user.avatarV1Web || null,
        oldAvatar: user.oldAvatar || null,
        fallbackAvatar: user.avatar || null
    });
};


/***/ }),

/***/ 64250:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _emotion_styled__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(95934);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(45697);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _utils_styleHelper__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(54540);
/* harmony import */ var _styles_index__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(2080);




var H4 = /*#__PURE__*/ (0,_emotion_styled__WEBPACK_IMPORTED_MODULE_0__["default"])("h4", {
    target: "e1nt2v9v0",
    label: "H4"
})("font-weight:", _styles_index__WEBPACK_IMPORTED_MODULE_2__/* .Fonts.BOLD */ .F3.Pl, ";font-size:", _styles_index__WEBPACK_IMPORTED_MODULE_2__/* .Fonts.H4 */ .F3.H4, ";line-height:", _styles_index__WEBPACK_IMPORTED_MODULE_2__/* .Fonts.HEADER_LINE_HEIGHT */ .F3.rm, ";color:", function(param) {
    var color = param.color;
    return color;
}, ";margin:", _styles_index__WEBPACK_IMPORTED_MODULE_2__/* .Spacings.SPACING_0B */ .t8.NE, ";@media only screen and (max-width:", _styles_index__WEBPACK_IMPORTED_MODULE_2__/* .breakpoints.tablet */ .AV.tablet, "){font-size:16px;line-height:100%;}", function(param) {
    var lineClamp = param.lineClamp;
    return lineClamp ? _utils_styleHelper__WEBPACK_IMPORTED_MODULE_1__/* ["default"].lineClampStyle */ .Z.lineClampStyle(lineClamp) : null;
});
/* harmony default export */ __webpack_exports__["Z"] = (H4);
H4.propTypes = {
    color: (prop_types__WEBPACK_IMPORTED_MODULE_3___default().string),
    lineClamp: (prop_types__WEBPACK_IMPORTED_MODULE_3___default().number)
};
H4.defaultProps = {
    color: "var(--color-text-primary)",
    lineClamp: null
};


/***/ }),

/***/ 42531:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(35944);
/* harmony import */ var _emotion_styled__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(95934);
/* harmony import */ var _material_ui_core_IconButton__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(17812);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(45697);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var _utils_boxShadowGenerator__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(87312);
/* harmony import */ var _styles_index__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(2080);






var whiteV2 = "var(--color-base-1)";
var StyledIconButton = /*#__PURE__*/ (0,_emotion_styled__WEBPACK_IMPORTED_MODULE_0__["default"])(_material_ui_core_IconButton__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
    target: "egd2nd0",
    label: "StyledIconButton"
})("background-color:", function(param) {
    var $bgColor = param.$bgColor;
    return $bgColor || whiteV2;
}, ";border-radius:", _styles_index__WEBPACK_IMPORTED_MODULE_2__/* .Spacings.SPACING_2B */ .t8.Rw, ";height:", _styles_index__WEBPACK_IMPORTED_MODULE_2__/* .Spacings.SPACING_8B */ .t8.B3, ";width:", _styles_index__WEBPACK_IMPORTED_MODULE_2__/* .Spacings.SPACING_8B */ .t8.B3, ";box-shadow:", (0,_utils_boxShadowGenerator__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(), ";padding:", _styles_index__WEBPACK_IMPORTED_MODULE_2__/* .Spacings.SPACING_0B */ .t8.NE, ";&:hover{background-color:", function(param) {
    var $hovDisabled = param.$hovDisabled, $bgColor = param.$bgColor;
    return $hovDisabled ? $bgColor || whiteV2 : "var(--color-base-1)";
}, ";}");
var IconButton = function(param) {
    var children = param.children, className = param.className, onClick = param.onClick, bgColor = param.bgColor, hovDisabled = param.hovDisabled;
    return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__/* .jsx */ .tZ)(StyledIconButton, {
        disableRipple: true,
        className: className,
        onClick: onClick,
        $bgColor: bgColor,
        $hovDisabled: hovDisabled,
        children: children
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (IconButton);
IconButton.propTypes = {
    className: (prop_types__WEBPACK_IMPORTED_MODULE_5___default().string),
    children: (prop_types__WEBPACK_IMPORTED_MODULE_5___default().node.isRequired),
    onClick: (prop_types__WEBPACK_IMPORTED_MODULE_5___default().func),
    bgColor: (prop_types__WEBPACK_IMPORTED_MODULE_5___default().string),
    hovDisabled: (prop_types__WEBPACK_IMPORTED_MODULE_5___default().bool)
};
IconButton.defaultProps = {
    className: "",
    onClick: function() {},
    bgColor: "",
    hovDisabled: false
};


/***/ }),

/***/ 55161:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(35944);
/* harmony import */ var _material_ui_core_Menu__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(21322);
/* harmony import */ var _emotion_styled__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(95934);
/* harmony import */ var _emotion_react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(70917);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(45697);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var _utils_boxShadowGenerator__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(87312);






var keyFrameOpen = function(height) {
    return /*#__PURE__*/ (0,_emotion_react__WEBPACK_IMPORTED_MODULE_2__.keyframes)("0%{max-height:0px;}50%{max-height:", height || "276px", ";padding-bottom:20px;}100%{padding-bottom:0px;}", "keyFrameOpen");
};
var keyFrameClose = function(height) {
    return /*#__PURE__*/ (0,_emotion_react__WEBPACK_IMPORTED_MODULE_2__.keyframes)("0%{padding-bottom:20px;max-height:", height || "276px", ";}100%{padding-bottom:0px;max-height:0px;}", "keyFrameClose");
};
var animationOpen = function(height) {
    return /*#__PURE__*/ (0,_emotion_react__WEBPACK_IMPORTED_MODULE_2__.css)(keyFrameOpen(height), " 300ms ease-in 0s", "animationOpen");
};
var animationClose = function(height) {
    return /*#__PURE__*/ (0,_emotion_react__WEBPACK_IMPORTED_MODULE_2__.css)(keyFrameClose(height), " 300ms ease-out 0s", "animationClose");
};
var StyledMenu = /*#__PURE__*/ (0,_emotion_styled__WEBPACK_IMPORTED_MODULE_0__["default"])(_material_ui_core_Menu__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
    target: "elxihdt0",
    label: "StyledMenu"
})("&.MuiPopover-root .MuiPaper-root{width:", function(param) {
    var width = param.width;
    return width;
}, ";border:", function(param) {
    var $noBorder = param.$noBorder;
    return $noBorder ? "none" : "1px solid var(--color-shadow)";
}, ";border-radius:8px;margin-top:10px;background-color:var(--color-base-1);box-shadow:", (0,_utils_boxShadowGenerator__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(), ";transform:none !important;opacity:1 !important;animation:", function(param) {
    var open = param.open, height = param.height;
    return open ? animationOpen(height) : animationClose(height);
}, ";max-height:", function(param) {
    var height = param.height;
    return height;
}, ";-ms-overflow-style:none;/* Internet Explorer 10+ */\n    scrollbar-width:none;/* Firefox */\n    /* Chrome and IOS Safari */::-webkit-scrollbar{width:0px;background:transparent;}}&.MuiPopover-root .MuiMenu-list{padding-top:", function(param) {
    var $noPadding = param.$noPadding;
    return $noPadding ? "0px" : "8px";
}, ";padding-bottom:", function(param) {
    var $noPadding = param.$noPadding;
    return $noPadding ? "0px" : "8px";
}, ";}");
var Menu = function(param) {
    var children = param.children, anchorEl = param.anchorEl, onClose = param.onClose, position = param.position, width = param.width, height = param.height, noPadding = param.noPadding, noBorder = param.noBorder, anchorOrigin = param.anchorOrigin, transformOrigin = param.transformOrigin, className = param.className, disablePortal = param.disablePortal;
    return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__/* .jsx */ .tZ)(StyledMenu, {
        className: className,
        anchorEl: anchorEl,
        open: Boolean(anchorEl),
        onClose: onClose,
        elevation: 0,
        getContentAnchorEl: null,
        anchorOrigin: anchorOrigin || {
            vertical: "bottom",
            horizontal: position
        },
        transformOrigin: transformOrigin || {
            vertical: "top",
            horizontal: position
        },
        variant: "menu",
        transitionDuration: 200,
        width: width,
        height: height,
        $noPadding: noPadding,
        $noBorder: noBorder,
        disablePortal: disablePortal,
        children: children
    });
};
Menu.propTypes = {
    children: (prop_types__WEBPACK_IMPORTED_MODULE_5___default().node.isRequired),
    onClose: (prop_types__WEBPACK_IMPORTED_MODULE_5___default().func.isRequired),
    anchorOrigin: prop_types__WEBPACK_IMPORTED_MODULE_5___default().objectOf((prop_types__WEBPACK_IMPORTED_MODULE_5___default().any)),
    transformOrigin: prop_types__WEBPACK_IMPORTED_MODULE_5___default().objectOf((prop_types__WEBPACK_IMPORTED_MODULE_5___default().any)),
    position: prop_types__WEBPACK_IMPORTED_MODULE_5___default().oneOf([
        "left",
        "center",
        "right"
    ]),
    width: (prop_types__WEBPACK_IMPORTED_MODULE_5___default().string),
    height: (prop_types__WEBPACK_IMPORTED_MODULE_5___default().string),
    noPadding: (prop_types__WEBPACK_IMPORTED_MODULE_5___default().bool),
    noBorder: (prop_types__WEBPACK_IMPORTED_MODULE_5___default().bool),
    anchorEl: prop_types__WEBPACK_IMPORTED_MODULE_5___default().oneOf([
        null,
        (prop_types__WEBPACK_IMPORTED_MODULE_5___default().node)
    ]),
    className: (prop_types__WEBPACK_IMPORTED_MODULE_5___default().string),
    disablePortal: (prop_types__WEBPACK_IMPORTED_MODULE_5___default().bool)
};
Menu.defaultProps = {
    anchorOrigin: null,
    transformOrigin: null,
    position: "left",
    width: "auto",
    height: "276px",
    noPadding: false,
    noBorder: false,
    anchorEl: null,
    className: "",
    disablePortal: false
};
/* harmony default export */ __webpack_exports__["Z"] = (Menu);


/***/ }),

/***/ 8477:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(35944);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var _emotion_styled__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(95934);
/* harmony import */ var lodash_isNil__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(14293);
/* harmony import */ var lodash_isNil__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(lodash_isNil__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(45697);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_10___default = /*#__PURE__*/__webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_10__);
/* harmony import */ var _base_Menu_Menu__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(55161);
/* harmony import */ var _base_H6_H6__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(10076);
/* harmony import */ var _icon_KeyboardArrowDown__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(21572);
/* harmony import */ var _utils_boxShadowGenerator__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(87312);
/* harmony import */ var _styles_index__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(2080);
/* harmony import */ var _MenuItem__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(98811);

/* eslint-disable react/display-name */ /* eslint-disable react/prop-types */ 









var DropDownButton = /*#__PURE__*/ (0,_emotion_styled__WEBPACK_IMPORTED_MODULE_1__["default"])("button", {
    target: "e1v4hctf0",
    label: "DropDownButton"
})("display:flex;justify-content:space-between;min-width:fit-content;align-self:center;align-items:center;line-height:150%;cursor:", function(param) {
    var $isDisabled = param.$isDisabled;
    return $isDisabled ? "not-allowed" : "pointer";
}, ";transition:all 400ms ease-in-out;border-width:1px;border-style:solid;font-weight:600;border-radius:", _styles_index__WEBPACK_IMPORTED_MODULE_7__/* .Spacings.SPACING_2B */ .t8.Rw, ";background-color:var(--color-base-1);grid-column:", function(param) {
    var gridColumn = param.gridColumn;
    return gridColumn;
}, ";padding:", _styles_index__WEBPACK_IMPORTED_MODULE_7__/* .Spacings.SPACING_3B */ .t8.N, " ", _styles_index__WEBPACK_IMPORTED_MODULE_7__/* .Spacings.SPACING_4B */ .t8.BM, ";font-size:", _styles_index__WEBPACK_IMPORTED_MODULE_7__/* .Fonts.SMALL */ .F3.HC, ";color:var(--color-text-primary);box-shadow:", (0,_utils_boxShadowGenerator__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(), ";border-color:", function(param) {
    var showSelectedBorder = param.showSelectedBorder, open = param.open;
    if (showSelectedBorder) return "var(--color-text-primary)";
    if (open) return "var(--color-divider)";
    return "var(--color-shadow)";
}, ";", function(param) {
    var buttonWidth = param.buttonWidth;
    return buttonWidth && "width: ".concat(buttonWidth, ";");
}, ":hover{background-color:var(--color-base-1);border-color:", function(param) {
    var showSelectedBorder = param.showSelectedBorder;
    return showSelectedBorder ? "var(--color-text-primary)" : "var(--color-divider)";
}, ";box-shadow:", (0,_utils_boxShadowGenerator__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)({
    yOffset: _styles_index__WEBPACK_IMPORTED_MODULE_7__/* .Spacings.SPACING_2B */ .t8.Rw,
    blur: _styles_index__WEBPACK_IMPORTED_MODULE_7__/* .Spacings.SPACING_2B */ .t8.Rw
}), ";}@media (max-width:", _styles_index__WEBPACK_IMPORTED_MODULE_7__/* .breakpoints.mobile */ .AV.mobile, "){font-size:12px;padding:", _styles_index__WEBPACK_IMPORTED_MODULE_7__/* .Spacings.SPACING_2B */ .t8.Rw, " ", _styles_index__WEBPACK_IMPORTED_MODULE_7__/* .Spacings.SPACING_3B */ .t8.N, ";white-space:nowrap;grid-column:", function(param) {
    var mwGridColumn = param.mwGridColumn;
    return mwGridColumn || "auto";
}, " !important;}");
var Button = /*#__PURE__*/ (0,react__WEBPACK_IMPORTED_MODULE_0__.forwardRef)(function(param, ref) {
    var open = param.open, onClick = param.onClick, gridColumn = param.gridColumn, mwGridColumn = param.mwGridColumn, children = param.children, showSelectedBorder = param.showSelectedBorder, className = param.className, buttonWidth = param.buttonWidth, $isDisabled = param.$isDisabled;
    return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__/* .jsx */ .tZ)(DropDownButton, {
        open: open,
        onClick: onClick,
        gridColumn: gridColumn,
        mwGridColumn: mwGridColumn,
        ref: ref,
        showSelectedBorder: showSelectedBorder,
        className: className,
        type: "button",
        buttonWidth: buttonWidth,
        $isDisabled: $isDisabled,
        children: children
    });
});
var StyledArrowDown = /*#__PURE__*/ (0,_emotion_styled__WEBPACK_IMPORTED_MODULE_1__["default"])(_icon_KeyboardArrowDown__WEBPACK_IMPORTED_MODULE_5__["default"], {
    target: "e1v4hctf1",
    label: "StyledArrowDown"
})("transition:transform 400ms ease-in-out;transform:", function(param) {
    var open = param.open;
    return open ? "rotate(180deg)" : "rotate(0deg)";
}, ";@media only screen and (max-width:47.95em){margin-left:8px;}");
var IconWrapper = /*#__PURE__*/ (0,_emotion_styled__WEBPACK_IMPORTED_MODULE_1__["default"])("div", {
    target: "e1v4hctf2",
    label: "IconWrapper"
})("margin-right:", _styles_index__WEBPACK_IMPORTED_MODULE_7__/* .Spacings.SPACING_2B */ .t8.Rw, ";display:flex;");
var getFavoriteKey = function(option) {
    return [
        "value",
        "code",
        "id",
        "uid"
    ].find(function(key) {
        return Object.keys(option || {}).some(function(k) {
            return k === key;
        });
    });
};
var selectedOptionHasValueOrId = function(selectedOption) {
    var favoriteKey = getFavoriteKey(selectedOption);
    return !lodash_isNil__WEBPACK_IMPORTED_MODULE_2___default()(selectedOption === null || selectedOption === void 0 ? void 0 : selectedOption[favoriteKey]);
};
var isDefined = function(value) {
    return !(value === undefined || value === null);
};
var isSelected = function(selectedOption, option) {
    var favoriteKey = getFavoriteKey(selectedOption);
    if (isDefined(selectedOption === null || selectedOption === void 0 ? void 0 : selectedOption[favoriteKey]) && (selectedOption === null || selectedOption === void 0 ? void 0 : selectedOption[favoriteKey]) === (option === null || option === void 0 ? void 0 : option[favoriteKey])) return true;
    return false;
};
var Dropdown = /*#__PURE__*/ (0,react__WEBPACK_IMPORTED_MODULE_0__.forwardRef)(function(props, ref) {
    var _options = props.options, options = _options === void 0 ? [] : _options, selectedOption = props.selectedOption, onOptionClick = props.onOptionClick, onClick = props.onClick, displayCheck = props.displayCheck, children = props.children, gridColumn = props.gridColumn, mwGridColumn = props.mwGridColumn, links = props.links, isDisabled = props.isDisabled, stripLength = props.stripLength, showSelectedBorder = props.showSelectedBorder, className = props.className, openDropDown = props.openDropDown, closeDropdown = props.closeDropdown, state = props.state, useOuterState = props.useOuterState, displayIcon = props.displayIcon, menuWidth = props.menuWidth, menuHeight = props.menuHeight, buttonWidth = props.buttonWidth, placeholder = props.placeholder, menuColor = props.menuColor, topChildren = props.topChildren, showIcon = props.showIcon, textColor = props.textColor, getKey = props.getKey, disablePortal = props.disablePortal;
    var _$ref = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(null), anchorEl = _$ref[0], setAnchorEl = _$ref[1];
    var handleClick = function(event) {
        onClick();
        if (isDisabled) {
            return;
        }
        if (useOuterState) openDropDown(event.currentTarget);
        else setAnchorEl(event.currentTarget);
    };
    var handleClose = function() {
        if (useOuterState) closeDropdown();
        else setAnchorEl(null);
    };
    var handleOptionClick = function(option) {
        onOptionClick(option);
        handleClose();
    };
    var stripLabel = function(label) {
        if (stripLength && (label === null || label === void 0 ? void 0 : label.length) > stripLength) return "".concat(label.substr(0, stripLength), " ...");
        return label;
    };
    var stateOrAnchor = state || anchorEl;
    return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__/* .jsxs */ .BX)(_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__/* .Fragment */ .HY, {
        children: [
            /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__/* .jsxs */ .BX)(Button, {
                open: stateOrAnchor,
                onClick: handleClick,
                gridColumn: gridColumn,
                mwGridColumn: mwGridColumn,
                ref: ref,
                showSelectedBorder: showSelectedBorder && selectedOptionHasValueOrId(selectedOption),
                className: className,
                buttonWidth: buttonWidth,
                $isDisabled: isDisabled,
                children: [
                    displayIcon ? /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__/* .jsx */ .tZ)(IconWrapper, {
                        className: "iconWrapper",
                        children: displayIcon
                    }) : null,
                    selectedOption ? stripLabel(selectedOption.label || selectedOption.name || selectedOption.display_name || "No preference") : /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__/* .jsx */ .tZ)(_base_H6_H6__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
                        color: textColor || "var(--color-text-secondary)",
                        children: placeholder
                    }),
                    /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__/* .jsx */ .tZ)(StyledArrowDown, {
                        open: stateOrAnchor,
                        size: "16px",
                        color: "var(--color-text-primary)"
                    })
                ]
            }),
            /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__/* .jsxs */ .BX)(_base_Menu_Menu__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                anchorEl: stateOrAnchor,
                onClose: handleClose,
                width: menuWidth,
                height: menuHeight,
                disablePortal: disablePortal,
                children: [
                    topChildren,
                    options.map(function(option, index) {
                        return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__/* .jsx */ .tZ)(_MenuItem__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z, {
                            displayCheck: displayCheck,
                            selected: isSelected(selectedOption, option),
                            option: option,
                            onClick: handleOptionClick,
                            links: links,
                            color: menuColor,
                            showIcon: showIcon
                        }, getKey(option) || index);
                    }),
                    children
                ]
            })
        ]
    });
});
/* harmony default export */ __webpack_exports__["Z"] = (Dropdown);
Dropdown.propTypes = {
    selectedOption: prop_types__WEBPACK_IMPORTED_MODULE_10___default().objectOf((prop_types__WEBPACK_IMPORTED_MODULE_10___default().any)),
    options: prop_types__WEBPACK_IMPORTED_MODULE_10___default().arrayOf((prop_types__WEBPACK_IMPORTED_MODULE_10___default().any)),
    onOptionClick: (prop_types__WEBPACK_IMPORTED_MODULE_10___default().func.isRequired),
    displayCheck: (prop_types__WEBPACK_IMPORTED_MODULE_10___default().bool),
    children: (prop_types__WEBPACK_IMPORTED_MODULE_10___default().node),
    gridColumn: (prop_types__WEBPACK_IMPORTED_MODULE_10___default().string),
    mwGridColumn: (prop_types__WEBPACK_IMPORTED_MODULE_10___default().string),
    links: (prop_types__WEBPACK_IMPORTED_MODULE_10___default().bool),
    stripLength: (prop_types__WEBPACK_IMPORTED_MODULE_10___default().number),
    showSelectedBorder: (prop_types__WEBPACK_IMPORTED_MODULE_10___default().bool),
    displayIcon: (prop_types__WEBPACK_IMPORTED_MODULE_10___default().node),
    onClick: (prop_types__WEBPACK_IMPORTED_MODULE_10___default().func),
    menuWidth: (prop_types__WEBPACK_IMPORTED_MODULE_10___default().string),
    menuHeight: (prop_types__WEBPACK_IMPORTED_MODULE_10___default().string),
    buttonWidth: (prop_types__WEBPACK_IMPORTED_MODULE_10___default().string),
    placeholder: (prop_types__WEBPACK_IMPORTED_MODULE_10___default().string),
    showIcon: (prop_types__WEBPACK_IMPORTED_MODULE_10___default().bool),
    getKey: (prop_types__WEBPACK_IMPORTED_MODULE_10___default().func),
    disablePortal: (prop_types__WEBPACK_IMPORTED_MODULE_10___default().bool)
};
Dropdown.defaultProps = {
    selectedOption: null,
    options: [],
    displayCheck: false,
    showIcon: false,
    children: null,
    gridColumn: "span 4",
    mwGridColumn: "auto",
    links: false,
    stripLength: null,
    showSelectedBorder: true,
    displayIcon: null,
    menuWidth: "233px",
    menuHeight: "276px",
    buttonWidth: null,
    onClick: function() {},
    placeholder: "",
    getKey: function(option) {
        return (option === null || option === void 0 ? void 0 : option.value) || (option === null || option === void 0 ? void 0 : option.id);
    },
    disablePortal: false
};


/***/ }),

/***/ 98811:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(35944);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var _emotion_styled__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(95934);
/* harmony import */ var _base_Link_Link__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(76356);
/* harmony import */ var _icon_Check__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(92542);
/* harmony import */ var _styles_index__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(2080);






var StyledItem = /*#__PURE__*/ (0,_emotion_styled__WEBPACK_IMPORTED_MODULE_1__["default"])("li", {
    target: "e10ouzx60",
    label: "StyledItem"
})("display:flex;align-items:center;padding:", _styles_index__WEBPACK_IMPORTED_MODULE_4__/* .Spacings.SPACING_2B */ .t8.Rw, " ", _styles_index__WEBPACK_IMPORTED_MODULE_4__/* .Spacings.SPACING_3B */ .t8.N, ";cursor:pointer;");
var LinkedLi = /*#__PURE__*/ (0,_emotion_styled__WEBPACK_IMPORTED_MODULE_1__["default"])("li", {
    target: "e10ouzx61",
    label: "LinkedLi"
})("cursor:pointer;");
var GoalImage = /*#__PURE__*/ (0,_emotion_styled__WEBPACK_IMPORTED_MODULE_1__["default"])("img", {
    target: "e10ouzx62",
    label: "GoalImage"
})("height:", _styles_index__WEBPACK_IMPORTED_MODULE_4__/* .Spacings.SPACING_8B */ .t8.B3, ";width:", _styles_index__WEBPACK_IMPORTED_MODULE_4__/* .Spacings.SPACING_8B */ .t8.B3, ";margin-right:", _styles_index__WEBPACK_IMPORTED_MODULE_4__/* .Spacings.SPACING_4B */ .t8.BM, ";");
var Label = /*#__PURE__*/ (0,_emotion_styled__WEBPACK_IMPORTED_MODULE_1__["default"])("span", {
    target: "e10ouzx63",
    label: "Label"
})("font-size:14px;line-height:150%;color:", function(param) {
    var selected = param.selected;
    return selected ? "var(--color-i-green)" : "var(--color-text-primary)";
}, ";color:", function(param) {
    var color = param.color, selected = param.selected;
    return selected && color;
}, ";flex-grow:1;display:block;font-weight:", function(param) {
    var selected = param.selected;
    return selected ? "bold" : "initial";
}, ";");
var anchorStyle = "display: flex; align-items: center; padding: 8px 16px;";
var item = function(selected, links, option, displayCheck, onMenuClick, color, ref, showIcon) {
    var _$ref = option || {}, selGoalIcon = _$ref.icon, selGoalName = _$ref.name, as = _$ref.as, href = _$ref.href, label = _$ref.label, name = _$ref.name, display_name = _$ref.display_name;
    var goalImage = /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__/* .jsx */ .tZ)(GoalImage, {
        src: selGoalIcon,
        alt: selGoalName
    });
    if (links) return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__/* .jsx */ .tZ)(LinkedLi, {
        onClick: onMenuClick,
        ref: ref,
        children: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__/* .jsxs */ .BX)(_base_Link_Link__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
            anchorStyle: anchorStyle,
            as: as,
            href: href,
            children: [
                showIcon && goalImage,
                /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__/* .jsx */ .tZ)(Label, {
                    selected: selected,
                    color: color,
                    children: option.label || option.name || option.display_name
                }),
                selected && displayCheck && /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__/* .jsx */ .tZ)(_icon_Check__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                    size: "24px",
                    color: "var(--color-i-green)"
                })
            ]
        })
    });
    return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__/* .jsxs */ .BX)(StyledItem, {
        ref: ref,
        onClick: onMenuClick,
        children: [
            showIcon && goalImage,
            /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__/* .jsx */ .tZ)(Label, {
                selected: selected,
                color: color,
                children: label || name || display_name || "No preference"
            }),
            selected && displayCheck && /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__/* .jsx */ .tZ)(_icon_Check__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                size: "24px",
                color: "var(--color-i-green)"
            })
        ]
    });
};
var MenuItem = function(param, ref) {
    var option = param.option, selected = param.selected, onClick = param.onClick, displayCheck = param.displayCheck, links = param.links, color = param.color, showIcon = param.showIcon;
    var onMenuClick = function() {
        return onClick(option);
    };
    return item(selected, links, option, displayCheck, onMenuClick, color, ref, showIcon);
};
/* harmony default export */ __webpack_exports__["Z"] = (/*#__PURE__*/(0,react__WEBPACK_IMPORTED_MODULE_0__.forwardRef)(MenuItem));


/***/ }),

/***/ 86727:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_18__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_19__ = __webpack_require__(69396);
/* harmony import */ var _emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_20__ = __webpack_require__(35944);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var _emotion_styled__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(95934);
/* harmony import */ var react_redux__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(52420);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_21__ = __webpack_require__(45697);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_21___default = /*#__PURE__*/__webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_21__);
/* harmony import */ var _base_P2_P2__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(72560);
/* harmony import */ var _base_H6_H6__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(10076);
/* harmony import */ var _base_Link_Link__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(76356);
/* harmony import */ var _utils_boxShadowGenerator__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(87312);
/* harmony import */ var _utils_textHelper__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(31309);
/* harmony import */ var _hooks_useGoalEventProps__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(52405);
/* harmony import */ var _hooks_useAllTypesOfCourseEventProps__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(96780);
/* harmony import */ var _styles_index__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(2080);
/* harmony import */ var _constants_segment__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(17579);
/* harmony import */ var _constants_index__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(43135);
/* harmony import */ var _actions_analytics__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(87936);
/* harmony import */ var _models_Topology__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(34482);
/* harmony import */ var _api_hooks_topology_useSelectedGoal__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(96487);
/* harmony import */ var _api_hooks_auth_useMyInfo__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(85780);
/* harmony import */ var _api_selectors_auth__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(73060);






















var Title = /*#__PURE__*/ (0,_emotion_styled__WEBPACK_IMPORTED_MODULE_1__["default"])(_base_H6_H6__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
    target: "eqs25d00",
    label: "Title"
})("margin-bottom:", _styles_index__WEBPACK_IMPORTED_MODULE_10__/* .Spacings.SPACING_1B */ .t8.MK, ";color:var(--color-text-primary);@media only screen and (max-width:", _styles_index__WEBPACK_IMPORTED_MODULE_10__/* .breakpoints.mobile */ .AV.mobile, "){font-size:16px;}");
var TopicGroupContainer = /*#__PURE__*/ (0,_emotion_styled__WEBPACK_IMPORTED_MODULE_1__["default"])("div", {
    target: "eqs25d01",
    label: "TopicGroupContainer"
})("display:grid;grid-template-columns:", function(param) {
    var $gridCols = param.$gridCols;
    return $gridCols;
}, ";grid-column-gap:", function(param) {
    var $colGap = param.$colGap;
    return $colGap;
}, ";width:100%;");
var CoursesInfo = /*#__PURE__*/ (0,_emotion_styled__WEBPACK_IMPORTED_MODULE_1__["default"])(_base_P2_P2__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
    target: "eqs25d02",
    label: "CoursesInfo"
})("display:flex;align-items:center;grid-row:2 / 3;grid-column:1 / 2;");
var TopicGroupCard = function(param) {
    var topology = param.topology, goal = param.goal, color = param.color, gridColumn = param.gridColumn, className = param.className, courseType = param.courseType, batch = param.batch, topicUID = param.topicUID, disabled = param.disabled, renderProgress = param.renderProgress, renderCourses = param.renderCourses, hideIfNoCourses = param.hideIfNoCourses, dataAnalytics = param.dataAnalytics, index = param.index, titleTag = param.titleTag, updateRecentSearchLog = param.updateRecentSearchLog, searchData = param.searchData;
    var ref;
    var dispatch = (0,react_redux__WEBPACK_IMPORTED_MODULE_2__/* .useDispatch */ .I0)();
    var topologyUID = topology.uid, _level = topology.level, level = _level === void 0 ? 30 : _level, name = topology.name;
    var selectedGoal = (0,_api_hooks_topology_useSelectedGoal__WEBPACK_IMPORTED_MODULE_15__/* ["default"] */ .ZP)().selectedGoal;
    var goalSegmentData = (0,_hooks_useGoalEventProps__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)({
        goalUID: batch === null || batch === void 0 ? void 0 : (ref = batch.goal) === null || ref === void 0 ? void 0 : ref.uid
    });
    var segmentData = (0,_hooks_useAllTypesOfCourseEventProps__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)({
        course: batch,
        isBatch: true
    });
    var meUID = (0,_api_hooks_auth_useMyInfo__WEBPACK_IMPORTED_MODULE_16__/* ["default"] */ .Z)(_api_selectors_auth__WEBPACK_IMPORTED_MODULE_17__/* .getMeUid */ .Up);
    var anchorStyle = "\n    height: ".concat(_styles_index__WEBPACK_IMPORTED_MODULE_10__/* .Spacings.SPACING_24B */ .t8.j2, ";\n    box-shadow: ").concat((0,_utils_boxShadowGenerator__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(), ";\n    padding: ").concat(_styles_index__WEBPACK_IMPORTED_MODULE_10__/* .Spacings.SPACING_6B */ .t8.BY, " ").concat(_styles_index__WEBPACK_IMPORTED_MODULE_10__/* .Spacings.SPACING_3B */ .t8.N, "\n    ").concat(_styles_index__WEBPACK_IMPORTED_MODULE_10__/* .Spacings.SPACING_6B */ .t8.BY, " ").concat(_styles_index__WEBPACK_IMPORTED_MODULE_10__/* .Spacings.SPACING_8B */ .t8.B3, ";\n    background-color: var(--color-base-1);\n    border-radius: ").concat(_styles_index__WEBPACK_IMPORTED_MODULE_10__/* .Spacings.SPACING_2B */ .t8.Rw, ";\n    border-left: ").concat(_styles_index__WEBPACK_IMPORTED_MODULE_10__/* .Spacings.SPACING_2B */ .t8.Rw, " ").concat(_styles_index__WEBPACK_IMPORTED_MODULE_10__/* .SOLID_BORDER_STYLE */ .T_, "\n      ").concat(color, ";\n    grid-column: span ").concat(gridColumn, ";\n    cursor: pointer;\n    :hover {\n      box-shadow: ").concat((0,_utils_boxShadowGenerator__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)({
        yOffset: _styles_index__WEBPACK_IMPORTED_MODULE_10__/* .Spacings.SPACING_1B */ .t8.MK,
        blur: _styles_index__WEBPACK_IMPORTED_MODULE_10__/* .Spacings.SPACING_2B */ .t8.Rw
    }), ";\n    }\n    transition: box-shadow 0.2s ease-in-out;\n    display: flex;\n    align-items: center;\n    @media only screen and (max-width: ").concat(_styles_index__WEBPACK_IMPORTED_MODULE_10__/* .breakpoints.mobile */ .AV.mobile, ") {\n      margin-bottom: 16px;\n      &.last {\n        margin-bottom: 56px;\n      }\n    }\n    ");
    var isBatch = _constants_index__WEBPACK_IMPORTED_MODULE_12__/* .itemTypes.BATCHES.includes */ .cs.BATCHES.includes(courseType);
    var getHref = function() {
        var href = null;
        if (courseType === "freeCourse") {
            href = "/goal/[goalSlug]/[goalUID]/free-platform/[topicSlugType]/[topicSlugUID]";
            if (topology.level === _constants_index__WEBPACK_IMPORTED_MODULE_12__/* .topologyLevels.CONCEPT */ .OP.CONCEPT) href = "/goal/[goalSlug]/[goalUID]/free-platform/[topicSlugType]/[topicSlugUID]/[conceptUID]";
        } else if (isBatch) href = "/batch/[slug]/[batchUID]/topics/[topicUID]";
        else if (courseType === _constants_index__WEBPACK_IMPORTED_MODULE_12__/* .itemTypes.CONCEPT */ .cs.CONCEPT) href = "/batch/[slug]/[batchUID]/topics/[topicUID]/courses/[conceptUID]";
        else {
            href = (0,_models_Topology__WEBPACK_IMPORTED_MODULE_14__/* .getLinkPath */ .bc)();
            if (topology.level === _constants_index__WEBPACK_IMPORTED_MODULE_12__/* .topologyLevels.TOPIC */ .OP.TOPIC) {
                href += "/courses";
            }
        }
        return href;
    };
    var getLink = function() {
        var link = null;
        var permalink = topology.permalink;
        if (courseType === "freeCourse") {
            link = "/goal/".concat(goal.slug, "/").concat(goal.uid, "/free-platform/").concat(topology.slug, "/").concat(topology.uid);
            if (topology.level === _constants_index__WEBPACK_IMPORTED_MODULE_12__/* .topologyLevels.CONCEPT */ .OP.CONCEPT) {
                var permalinkSplit = permalink.split("/");
                var parSlug = permalinkSplit[permalinkSplit.length - 3];
                link = "/goal/".concat(goal.slug, "/").concat(goal.uid, "/free-platform/").concat(parSlug, "/").concat(topology.slug, "/").concat(topology.uid);
            }
        } else if (isBatch) {
            link = "/batch/".concat(batch.slug, "/").concat(batch.uid, "/topics/").concat(topology.uid);
        } else if (courseType === _constants_index__WEBPACK_IMPORTED_MODULE_12__/* .itemTypes.CONCEPT */ .cs.CONCEPT) {
            link = "/batch/".concat(batch.slug, "/").concat(batch.uid, "/topics/").concat(topicUID, "/courses/").concat(topology.uid);
        } else {
            link = (0,_models_Topology__WEBPACK_IMPORTED_MODULE_14__/* .getTopicLink */ .pA)(topology, goal);
            if (topology.level === _constants_index__WEBPACK_IMPORTED_MODULE_12__/* .topologyLevels.TOPIC */ .OP.TOPIC) {
                link += "/courses";
            }
        }
        return link;
    };
    var handleAnalytics = function() {
        if (courseType === "search") {
            var nSearchData = (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_18__/* ["default"] */ .Z)({}, searchData);
            delete nSearchData.query;
            var position = nSearchData.position ? nSearchData.position : "See all";
            _actions_analytics__WEBPACK_IMPORTED_MODULE_13__/* .segment.track */ .EX.track(_constants_segment__WEBPACK_IMPORTED_MODULE_11__/* .SEARCH_RESULT_CLICKED */ .dW7, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_19__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_18__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_19__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_18__/* ["default"] */ .Z)({}, goalSegmentData), {
                sub_position: index + 1,
                last_primary_source: _constants_segment__WEBPACK_IMPORTED_MODULE_11__/* .SEARCH_RESULT_PAGE */ .jDH,
                last_primary_source_section: "Topic",
                search_section: "Global",
                current_screen: "Topic",
                eventName: _constants_segment__WEBPACK_IMPORTED_MODULE_11__/* .SEARCH_RESULT_CLICKED */ .dW7,
                eventType: "click",
                version: 2,
                objectID: "".concat(searchData.object_type, ":").concat(topologyUID),
                userToken: meUID
            }), nSearchData), {
                position: position
            }), _constants_index__WEBPACK_IMPORTED_MODULE_12__/* .evtNameCategoryMap.WITHOUT_CATEGORY */ .xK.WITHOUT_CATEGORY);
            dispatch(updateRecentSearchLog((0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_19__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_18__/* ["default"] */ .Z)({}, searchData), {
                entity_id: "".concat(searchData.object_type, ":").concat(topologyUID),
                goal_uid: selectedGoal.uid
            })));
        }
        var topologyName = _models_Topology__WEBPACK_IMPORTED_MODULE_14__/* .getTopologyName */ .yb[parseInt(level, 10)];
        var eventName = _constants_index__WEBPACK_IMPORTED_MODULE_12__/* .itemTypes.BATCHES.includes */ .cs.BATCHES.includes(courseType) ? _constants_segment__WEBPACK_IMPORTED_MODULE_11__/* .BATCH_SYLLABUS_VIEWED */ .wAP : _constants_segment__WEBPACK_IMPORTED_MODULE_11__/* .SYLLABUS_CARD_CLICKED */ .OB2;
        var eventKeys = isBatch ? _constants_segment__WEBPACK_IMPORTED_MODULE_11__/* .BATCH_KEYS */ .A8$ : _constants_segment__WEBPACK_IMPORTED_MODULE_11__/* .SYLLABUS_CLICKED_KEYS */ .Tk8;
        var eventData = (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_18__/* ["default"] */ .Z)({}, goalSegmentData);
        if (!isBatch) {
            eventData.topology_id = topologyUID;
            eventData.topology_level = topologyName;
            eventData.level = level;
            eventData.topology_name = name;
            eventData.start_date = batch.startsAt;
            eventData.end_date = batch.completedAt;
            eventData.batch_state = batch.state;
        } else {
            eventData = (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_18__/* ["default"] */ .Z)({}, eventData, segmentData);
        }
        _actions_analytics__WEBPACK_IMPORTED_MODULE_13__/* .segment.track */ .EX.track(eventName, eventData, _constants_index__WEBPACK_IMPORTED_MODULE_12__/* .evtNameCategoryMap.WITHOUT_CATEGORY */ .xK.WITHOUT_CATEGORY, true, eventKeys);
    };
    var topologyCoursesCount = (0,react__WEBPACK_IMPORTED_MODULE_0__.useMemo)(function() {
        if (courseType === "plus" || courseType === "syllabus") return topology.plusCourseCount;
        return topology.coursesCount || topology.courseCount || topology.course_count;
    }, [
        courseType,
        topology.plusCourseCount,
        topology.courseCount,
        topology.coursesCount,
        topology.course_count
    ]);
    var renderCoursesInfo = function() {
        if (renderCourses) {
            return renderCourses(topology, topologyCoursesCount);
        }
        return topologyCoursesCount ? (0,_utils_textHelper__WEBPACK_IMPORTED_MODULE_7__/* .pluralize */ ._6)(topologyCoursesCount, "course") : "Courses will be added soon";
    };
    return !hideIfNoCourses || topologyCoursesCount > 0 ? /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_20__/* .jsx */ .tZ)(_base_Link_Link__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
        href: getHref(),
        as: getLink(),
        anchorStyle: anchorStyle,
        className: className,
        disabled: disabled,
        onClick: handleAnalytics,
        children: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_20__/* .jsxs */ .BX)(TopicGroupContainer, {
            "data-analytics": "".concat(dataAnalytics, "-topic"),
            $colGap: renderProgress && topology.progress > 0 ? _styles_index__WEBPACK_IMPORTED_MODULE_10__/* .Spacings.SPACING_3B */ .t8.N : "0px",
            $gridCols: renderProgress && topology.progress > 0 ? "1fr max-content" : "1fr",
            children: [
                /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_20__/* .jsx */ .tZ)(Title, {
                    lineClamp: 1,
                    as: titleTag,
                    children: topology.name
                }),
                renderProgress && renderProgress(topology),
                courseType !== "concept" && /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_20__/* .jsx */ .tZ)(CoursesInfo, {
                    color: "var(--color-text-primary)",
                    children: renderCoursesInfo()
                })
            ]
        })
    }) : null;
};
/* harmony default export */ __webpack_exports__["Z"] = (TopicGroupCard);
TopicGroupCard.propTypes = {
    topology: prop_types__WEBPACK_IMPORTED_MODULE_21___default().objectOf((prop_types__WEBPACK_IMPORTED_MODULE_21___default().any)).isRequired,
    goal: prop_types__WEBPACK_IMPORTED_MODULE_21___default().objectOf((prop_types__WEBPACK_IMPORTED_MODULE_21___default().any)).isRequired,
    color: (prop_types__WEBPACK_IMPORTED_MODULE_21___default().string.isRequired),
    gridColumn: (prop_types__WEBPACK_IMPORTED_MODULE_21___default().number),
    className: (prop_types__WEBPACK_IMPORTED_MODULE_21___default().string),
    courseType: (prop_types__WEBPACK_IMPORTED_MODULE_21___default().string),
    batch: prop_types__WEBPACK_IMPORTED_MODULE_21___default().objectOf((prop_types__WEBPACK_IMPORTED_MODULE_21___default().any)),
    topicUID: (prop_types__WEBPACK_IMPORTED_MODULE_21___default().string.isRequired),
    disabled: (prop_types__WEBPACK_IMPORTED_MODULE_21___default().bool),
    renderProgress: (prop_types__WEBPACK_IMPORTED_MODULE_21___default().func),
    renderCourses: (prop_types__WEBPACK_IMPORTED_MODULE_21___default().func),
    hideIfNoCourses: (prop_types__WEBPACK_IMPORTED_MODULE_21___default().bool),
    dataAnalytics: (prop_types__WEBPACK_IMPORTED_MODULE_21___default().string),
    index: (prop_types__WEBPACK_IMPORTED_MODULE_21___default().number.isRequired),
    titleTag: (prop_types__WEBPACK_IMPORTED_MODULE_21___default().string),
    updateRecentSearchLog: (prop_types__WEBPACK_IMPORTED_MODULE_21___default().func),
    searchData: prop_types__WEBPACK_IMPORTED_MODULE_21___default().objectOf((prop_types__WEBPACK_IMPORTED_MODULE_21___default().any))
};
TopicGroupCard.defaultProps = {
    gridColumn: 6,
    className: "",
    courseType: null,
    batch: {},
    disabled: false,
    renderProgress: undefined,
    renderCourses: undefined,
    hideIfNoCourses: false,
    dataAnalytics: "",
    titleTag: "h3",
    updateRecentSearchLog: function() {},
    searchData: {}
};


/***/ }),

/***/ 96475:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ SeeAll_SeeAll; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/@emotion/react/jsx-runtime/dist/emotion-react-jsx-runtime.browser.esm.js
var emotion_react_jsx_runtime_browser_esm = __webpack_require__(35944);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(11163);
// EXTERNAL MODULE: ./node_modules/@emotion/styled/dist/emotion-styled.browser.esm.js + 2 modules
var emotion_styled_browser_esm = __webpack_require__(95934);
// EXTERNAL MODULE: ./node_modules/prop-types/index.js
var prop_types = __webpack_require__(45697);
var prop_types_default = /*#__PURE__*/__webpack_require__.n(prop_types);
// EXTERNAL MODULE: ./src/components/Composite/Dropdown/Dropdown.jsx
var Dropdown = __webpack_require__(8477);
// EXTERNAL MODULE: ./src/hooks/reduxHooks.js + 1 modules
var reduxHooks = __webpack_require__(88738);
// EXTERNAL MODULE: ./src/redux/actions/specialClasses.js
var specialClasses = __webpack_require__(23866);
// EXTERNAL MODULE: ./src/events/segmentStorage.js
var segmentStorage = __webpack_require__(71250);
// EXTERNAL MODULE: ./src/styleConstants/index.js
var styleConstants = __webpack_require__(2080);
// EXTERNAL MODULE: ./src/constants/index.js
var constants = __webpack_require__(43135);
// EXTERNAL MODULE: ./src/utils/feedTypeHelper.js
var feedTypeHelper = __webpack_require__(99682);
// EXTERNAL MODULE: ./src/components/Container/FeedTypeBlock/PopularSubjects.jsx
var PopularSubjects = __webpack_require__(1987);
// EXTERNAL MODULE: ./src/api/selectors/constants.js
var selectors_constants = __webpack_require__(17064);
// EXTERNAL MODULE: ./src/stores/sidenav.js
var sidenav = __webpack_require__(19204);
// EXTERNAL MODULE: ./src/layout/NavBar/PlusNavBar/plusNavBarItems.js
var plusNavBarItems = __webpack_require__(2990);
// EXTERNAL MODULE: ./src/redux/actions/analytics.js
var analytics = __webpack_require__(87936);
// EXTERNAL MODULE: ./src/constants/segment.js
var segment = __webpack_require__(17579);
// EXTERNAL MODULE: ./src/hooks/useGoalEventProps.js
var useGoalEventProps = __webpack_require__(52405);
// EXTERNAL MODULE: ./src/api/hooks/useConstants.js
var useConstants = __webpack_require__(79917);
// EXTERNAL MODULE: ./src/components/Container/SeeAll/TopBlock.jsx
var TopBlock = __webpack_require__(34229);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_to_consumable_array.mjs + 2 modules
var _to_consumable_array = __webpack_require__(29815);
// EXTERNAL MODULE: ./src/components/Base/CircularLoader/CircularLoader.jsx
var CircularLoader = __webpack_require__(13909);
// EXTERNAL MODULE: ./src/components/Composite/InfiniteList/InfiniteList.jsx + 1 modules
var InfiniteList = __webpack_require__(88074);
// EXTERNAL MODULE: ./src/components/Composite/EducatorDetailedCard/EducatorDetailedCard.jsx + 3 modules
var EducatorDetailedCard = __webpack_require__(13325);
// EXTERNAL MODULE: ./src/hooks/useFirstRenderSkip.js
var useFirstRenderSkip = __webpack_require__(6858);
// EXTERNAL MODULE: ./src/redux/constants/index.js
var redux_constants = __webpack_require__(94336);
// EXTERNAL MODULE: ./src/api/hooks/topology/useSelectedGoal.js
var useSelectedGoal = __webpack_require__(96487);
;// CONCATENATED MODULE: ./src/components/Container/SeeAll/EducatorFeed.jsx


















var FiltersContainer = /*#__PURE__*/ (0,emotion_styled_browser_esm["default"])("div", {
    target: "e2sut3d0",
    label: "FiltersContainer"
})("grid-column:span 18;display:grid;grid-template-columns:repeat(18,1fr);grid-column-gap:", styleConstants/* Spacings.SPACING_4B */.t8.BM, ";margin-top:", styleConstants/* Spacings.SPACING_6B */.t8.BY, ";@media only screen and (max-width:", styleConstants/* breakpoints.mobile */.AV.mobile, "){grid-column:span 10;grid-template-columns:repeat(10,1fr);margin-bottom:", styleConstants/* Spacings.SPACING_6B */.t8.BY, ";& button{width:auto;grid-column:span 10;height:45px;}}");
var ProgressContainer = /*#__PURE__*/ (0,emotion_styled_browser_esm["default"])("div", {
    target: "e2sut3d1",
    label: "ProgressContainer"
})("margin:", styleConstants/* Spacings.SPACING_8B */.t8.B3, ";grid-column:span 18;justify-content:center;display:flex;");
var getLanguageList = function(filters) {
    return filters.map(function(filter) {
        return {
            id: filter.language_id,
            value: filter.language,
            name: filter.language
        };
    });
};
var getTopicGroupList = function(filters) {
    return filters.map(function(filter) {
        return {
            id: filter.uid,
            value: filter.name,
            name: filter.name
        };
    });
};
var EducatorFeed = function(param) {
    var goalUID = param.goalUID, educatorFeedBlock = param.educatorFeedBlock, defaultBlockURL = param.defaultBlockURL, seeAllType = param.seeAllType, blockType = param.blockType, blockId = param.blockId, goalkey = param.goalkey, label = param.label, useLeaderboardMetaInfo = param.useLeaderboardMetaInfo;
    var ref;
    var ref1 = (0,react.useState)([]), languageOptions = ref1[0], setLanguageOptions = ref1[1];
    var ref2 = (0,useSelectedGoal/* default */.ZP)(), goal = ref2.selectedGoal;
    var ref3 = (0,react.useState)([]), topicGroupOptions = ref3[0], setTopicGroupOptions = ref3[1];
    var ref4 = (0,react.useState)(null), selectedLanguage = ref4[0], setSelectedLanguage = ref4[1];
    var ref5 = (0,react.useState)(null), selectedTopicGroup = ref5[0], setSelectedTopicGroup = ref5[1];
    var dispatch = (0,reduxHooks/* useDispatchToStore */.Ln)();
    (0,react.useEffect)(function() {
        dispatch((0,specialClasses/* fetchFiltersForEducatorList */.W6)(constants/* seeAllTypes.GOAL */.i0.GOAL, goalUID)).then(function(resp) {
            if (resp.type === "".concat(redux_constants/* courseTypes.GET_FILTERS_FOR_EDUCATORS_LIST */.Dl.GET_FILTERS_FOR_EDUCATORS_LIST, "_SUCCESS")) {
                setLanguageOptions([
                    {
                        id: "",
                        value: "All languages",
                        name: "All languages"
                    }
                ].concat((0,_to_consumable_array/* default */.Z)(getLanguageList(resp.result.languages))));
                setTopicGroupOptions([
                    {
                        id: "",
                        value: "All subjects",
                        name: "All subjects"
                    }
                ].concat((0,_to_consumable_array/* default */.Z)(getTopicGroupList(resp.result.topic_groups))));
            }
        });
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        goalUID
    ]);
    var renderEachEducator = function(educator, index) {
        return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(EducatorDetailedCard/* default */.Z, {
            educator: educator,
            gridColumn: "span 9",
            linkStyle: "margin-top: ".concat(styleConstants/* Spacings.SPACING_6B */.t8.BY, ";@media (max-width:47.95em){margin-top:").concat(index === 0 ? "0" : "", "}"),
            label: label,
            dataAnalytics: "goal",
            useLeaderboardMetaInfo: useLeaderboardMetaInfo,
            showBadge: true
        }, educator.uid);
    };
    var ref6 = (0,react.useState)(false), isFetching = ref6[0], setIsFetching = ref6[1];
    var handleFilterSelection = function(filterType) {
        return function(value) {
            analytics/* segment.track */.EX.track(segment/* FILTER_APPLIED */.pgu, {
                filter_type: filterType === "topicGroup" ? "Subject" : filterType,
                filter_value: value === null || value === void 0 ? void 0 : value.name,
                current_screen: "See All - Educators",
                goal_name: (goal === null || goal === void 0 ? void 0 : goal.name) || "NA",
                goal_uid: (goal === null || goal === void 0 ? void 0 : goal.uid) || "NA",
                subscription_duration: "NA",
                subscription_end_date: "NA",
                last_primary_source: "See All",
                last_primary_source_section: (goal === null || goal === void 0 ? void 0 : goal.name) ? "".concat(goal.name, " - Educators") : "NA"
            });
            if (filterType === "languages") setSelectedLanguage(value);
            else setSelectedTopicGroup(value);
        };
    };
    var loadMoreEducators = function() {
        var resetWithoutEmpty = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : false;
        var ref;
        var params = "".concat((selectedTopicGroup === null || selectedTopicGroup === void 0 ? void 0 : selectedTopicGroup.id) ? "topic_group_uid=".concat(selectedTopicGroup.id) : "").concat((selectedLanguage === null || selectedLanguage === void 0 ? void 0 : selectedLanguage.id) ? "".concat((selectedTopicGroup === null || selectedTopicGroup === void 0 ? void 0 : selectedTopicGroup.id) ? "&" : "", "language_id=").concat(selectedLanguage.id) : "");
        setIsFetching(resetWithoutEmpty);
        return (ref = dispatch((0,specialClasses/* fetchSeeAllTypeFeed */.NM)(goalUID, blockType, defaultBlockURL, blockId, seeAllType, true, resetWithoutEmpty, params))) === null || ref === void 0 ? void 0 : ref.then(function(res) {
            setIsFetching(false);
            return res;
        });
    };
    (0,useFirstRenderSkip/* default */.Z)(function() {
        loadMoreEducators(true);
    }, [
        selectedLanguage,
        selectedTopicGroup
    ]);
    if (educatorFeedBlock === null || educatorFeedBlock === void 0 ? void 0 : (ref = educatorFeedBlock[goalkey]) === null || ref === void 0 ? void 0 : ref.results) {
        return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(emotion_react_jsx_runtime_browser_esm/* Fragment */.HY, {
            children: [
                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(FiltersContainer, {
                    children: [
                        languageOptions.length > 1 && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Dropdown/* default */.Z, {
                            options: languageOptions,
                            onOptionClick: handleFilterSelection("languages"),
                            selectedOption: selectedLanguage || languageOptions[0],
                            placeholder: "Select Language",
                            menuWidth: "176px",
                            buttonWidth: "176px",
                            mwGridColumn: "span 5",
                            showSelectedBorder: false,
                            stripLength: 15
                        }),
                        topicGroupOptions.length > 1 && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Dropdown/* default */.Z, {
                            options: topicGroupOptions,
                            onOptionClick: handleFilterSelection("topicGroup"),
                            selectedOption: selectedTopicGroup || topicGroupOptions[0],
                            placeholder: "Select Topic",
                            menuWidth: "176px",
                            buttonWidth: "176px",
                            mwGridColumn: "span 5",
                            showSelectedBorder: false,
                            stripLength: 15
                        })
                    ]
                }),
                isFetching ? /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(ProgressContainer, {
                    children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CircularLoader/* default */.Z, {})
                }) : /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(InfiniteList["default"], {
                    data: educatorFeedBlock[goalkey],
                    loadMore: loadMoreEducators,
                    _renderItem: renderEachEducator,
                    gridColumn: "span 18"
                })
            ]
        });
    }
    return null;
};
EducatorFeed.propTypes = {
    goalUID: (prop_types_default()).string.isRequired,
    educatorFeedBlock: prop_types_default().objectOf((prop_types_default()).any).isRequired,
    defaultBlockURL: (prop_types_default()).string.isRequired,
    seeAllType: (prop_types_default()).string.isRequired,
    blockType: (prop_types_default()).string.isRequired,
    blockId: (prop_types_default()).string.isRequired,
    goalkey: (prop_types_default()).string.isRequired,
    label: (prop_types_default()).string.isRequired,
    useLeaderboardMetaInfo: (prop_types_default()).bool
};
EducatorFeed.defaultProps = {
    useLeaderboardMetaInfo: false
};
/* harmony default export */ var SeeAll_EducatorFeed = (EducatorFeed);

// EXTERNAL MODULE: ./src/components/Container/SeeAll/ClassFeedBlock.jsx
var ClassFeedBlock = __webpack_require__(93211);
// EXTERNAL MODULE: ./src/components/Composite/Dialog/Dialog.tsx + 1 modules
var Dialog = __webpack_require__(76920);
// EXTERNAL MODULE: ./src/components/Composite/TestSeriesCard/TestSeriesCard.jsx
var TestSeriesCard = __webpack_require__(13272);
// EXTERNAL MODULE: ./src/redux/actions/courses.js
var courses = __webpack_require__(5861);
;// CONCATENATED MODULE: ./src/components/Container/SeeAll/TestSeriesFeedBlock.jsx









var TestSeriesFeedBlock = function(param) {
    var goalUID = param.goalUID, testSeriesFeedBlock = param.testSeriesFeedBlock, goalkey = param.goalkey, blockId = param.blockId, defaultBlockURL = param.defaultBlockURL, seeAllType = param.seeAllType, blockType = param.blockType, label = param.label;
    var ref;
    var dispatch = (0,reduxHooks/* useDispatchToStore */.Ln)();
    var ref1 = (0,react.useState)(false), unEnrollModalOpen = ref1[0], setUnEnrollModalOpen = ref1[1];
    var ref2 = (0,react.useState)(null), courseSelected = ref2[0], setcourseSelected = ref2[1];
    var message = "This course will be removed from your schedule and you will stop receiving updates related to this course";
    var acceptOnClick = function() {
        dispatch((0,courses/* toggleEnrolledCourse */.eL)(courseSelected, false));
        setUnEnrollModalOpen(false);
    };
    var onCloseModal = function() {
        setUnEnrollModalOpen(false);
        setcourseSelected(null);
    };
    var renderEachClass = function(testData, index) {
        return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(TestSeriesCard/* default */.Z, {
            test: testData,
            index: index,
            label: label
        }, testData.uid);
    };
    var loadMoreClasses = function() {
        return dispatch((0,specialClasses/* fetchSeeAllTypeFeed */.NM)(goalUID, blockType, defaultBlockURL, blockId, seeAllType, true));
    };
    if ((ref = testSeriesFeedBlock[goalkey]) === null || ref === void 0 ? void 0 : ref.results) {
        return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(emotion_react_jsx_runtime_browser_esm/* Fragment */.HY, {
            children: [
                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Dialog["default"], {
                    onClose: onCloseModal,
                    dialogState: unEnrollModalOpen,
                    heading: "Are you sure you want to unenroll?",
                    message: message,
                    acceptLabel: "Unenroll",
                    rejectLabel: "Cancel",
                    acceptOnClick: acceptOnClick,
                    rejectOnClick: onCloseModal
                }),
                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(InfiniteList["default"], {
                    loadMore: loadMoreClasses,
                    _renderItem: renderEachClass,
                    data: testSeriesFeedBlock[goalkey],
                    gridColumn: "span 18"
                })
            ]
        });
    }
    return null;
};
/* harmony default export */ var SeeAll_TestSeriesFeedBlock = (TestSeriesFeedBlock);
TestSeriesFeedBlock.propTypes = {
    goalUID: (prop_types_default()).string.isRequired,
    goalkey: (prop_types_default()).string.isRequired,
    blockId: (prop_types_default()).string.isRequired,
    defaultBlockURL: (prop_types_default()).string.isRequired,
    seeAllType: (prop_types_default()).string.isRequired,
    blockType: (prop_types_default()).string.isRequired,
    testSeriesFeedBlock: prop_types_default().objectOf((prop_types_default()).any).isRequired,
    label: (prop_types_default()).string.isRequired
};

// EXTERNAL MODULE: ./src/components/Composite/TopicGroupCard/TopicGroupCard.jsx
var TopicGroupCard = __webpack_require__(86727);
// EXTERNAL MODULE: ./src/utils/textHelper.js
var textHelper = __webpack_require__(31309);
;// CONCATENATED MODULE: ./src/components/Container/SeeAll/TopicFeedBlock.jsx










var TopicFeedBlock = function(param) {
    var goalUID = param.goalUID, topicFeedBlock = param.topicFeedBlock, goalkey = param.goalkey, blockId = param.blockId, defaultBlockURL = param.defaultBlockURL, seeAllType = param.seeAllType, blockType = param.blockType, goal = param.goal, onClick = param.onClick, label = param.label;
    var ref;
    var dispatch = (0,reduxHooks/* useDispatchToStore */.Ln)();
    var ref1 = (0,react.useState)(false), unEnrollModalOpen = ref1[0], setUnEnrollModalOpen = ref1[1];
    var ref2 = (0,react.useState)(null), courseSelected = ref2[0], setcourseSelected = ref2[1];
    var message = "This course will be removed from your schedule and you will stop receiving updates related to this course";
    var acceptOnClick = function() {
        dispatch((0,courses/* toggleEnrolledCourse */.eL)(courseSelected, false));
        setUnEnrollModalOpen(false);
    };
    var onCloseModal = function() {
        setUnEnrollModalOpen(false);
        setcourseSelected(null);
    };
    var renderEachClass = function(topic, index) {
        return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(TopicGroupCard/* default */.Z, {
            dispatch: dispatch,
            content: (0,textHelper/* pluralize */._6)(topic.coursesCount, "course"),
            color: topic.color,
            onClick: onClick,
            topology: topic,
            goal: goal,
            index: index,
            label: label
        }, topic.uid);
    };
    var loadMoreClasses = function() {
        return dispatch((0,specialClasses/* fetchSeeAllTypeFeed */.NM)(goalUID, blockType, defaultBlockURL, blockId, seeAllType, true));
    };
    if ((ref = topicFeedBlock[goalkey]) === null || ref === void 0 ? void 0 : ref.results) {
        return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(emotion_react_jsx_runtime_browser_esm/* Fragment */.HY, {
            children: [
                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Dialog["default"], {
                    onClose: onCloseModal,
                    dialogState: unEnrollModalOpen,
                    heading: "Are you sure you want to unenroll?",
                    message: message,
                    acceptLabel: "Unenroll",
                    rejectLabel: "Cancel",
                    acceptOnClick: acceptOnClick,
                    rejectOnClick: onCloseModal
                }),
                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(InfiniteList["default"], {
                    loadMore: loadMoreClasses,
                    _renderItem: renderEachClass,
                    data: topicFeedBlock[goalkey],
                    gridColumn: "span 18"
                })
            ]
        });
    }
    return null;
};
/* harmony default export */ var SeeAll_TopicFeedBlock = (TopicFeedBlock);
TopicFeedBlock.propTypes = {
    goalUID: (prop_types_default()).string.isRequired,
    topicFeedBlock: prop_types_default().objectOf((prop_types_default()).any).isRequired,
    blockId: (prop_types_default()).string.isRequired,
    defaultBlockURL: (prop_types_default()).string.isRequired,
    seeAllType: (prop_types_default()).string.isRequired,
    blockType: (prop_types_default()).string.isRequired,
    goalkey: (prop_types_default()).string.isRequired,
    goal: prop_types_default().objectOf((prop_types_default()).any).isRequired,
    onClick: (prop_types_default()).func.isRequired,
    label: (prop_types_default()).string.isRequired
};

;// CONCATENATED MODULE: ./src/components/Container/SeeAll/SeeAll.jsx



























var DropdownWrapper = /*#__PURE__*/ (0,emotion_styled_browser_esm["default"])("div", {
    target: "egt9xxi0",
    label: "DropdownWrapper"
})("grid-column:span 18;display:grid;grid-template-columns:repeat(18,1fr);grid-column-gap:", styleConstants/* Spacings.SPACING_4B */.t8.BM, ";@media only screen and (max-width:", styleConstants/* breakpoints.mobile */.AV.mobile, "){margin-bottom:", styleConstants/* Spacings.SPACING_6B */.t8.BY, ";}");
var filterMenuItems = function(tabs) {
    return tabs.map(function(tab) {
        return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, tab), {
            value: tab.label.toLowerCase()
        });
    });
};
var SeeAll = function(param) {
    var seeAllType = param.seeAllType, useLeaderboardMetaInfo = param.useLeaderboardMetaInfo, pageType = param.pageType;
    var ref, ref1, ref2, ref3, ref4;
    var router = (0,next_router.useRouter)();
    var dispatch = (0,reduxHooks/* useDispatchToStore */.Ln)();
    var _query = router.query, topicSlugType = _query.topicSlugType, goalUID = _query.goalUID, type = _query.type;
    if (seeAllType !== constants/* seeAllTypes.GOAL */.i0.GOAL && seeAllType !== constants/* seeAllTypes.SPECIAL_CLASS */.i0.SPECIAL_CLASS) type = topicSlugType;
    var isGTP = (0,useConstants/* default */.Z)((0,selectors_constants/* getIsGTPGoal */.vf)(goalUID));
    var goalSlug = "iit-jee";
    var goalInfo = (0,reduxHooks/* useSelectorToStore */.nZ)(function(param) {
        var topologies = param.topologies;
        return topologies.topologyDetails[goalUID];
    });
    var classes = (0,reduxHooks/* useSelectorToStore */.nZ)(function(param) {
        var paginator = param.paginator;
        return paginator.seeAllTypeFeed;
    });
    var popularSubjects = (0,reduxHooks/* useSelectorToStore */.nZ)(function(param) {
        var courses = param.courses;
        return courses.allPopularSubjects;
    });
    var blockInfo = (0,reduxHooks/* useSelectorToStore */.nZ)(function(param) {
        var courses = param.courses;
        return courses.seeAllFeedEBInfo[(0,feedTypeHelper/* getBlockInfoKey */.z9)(seeAllType, goalUID, type)];
    });
    var blockId = blockInfo.id;
    var ref5 = (0,react.useState)((0,_object_spread/* default */.Z)({
        value: blockInfo === null || blockInfo === void 0 ? void 0 : (ref = blockInfo.tabs) === null || ref === void 0 ? void 0 : ref[0].label.toLowerCase()
    }, (ref1 = blockInfo.tabs) === null || ref1 === void 0 ? void 0 : ref1[0])), selectedMenu = ref5[0], changeSelectedClassType = ref5[1];
    var goalSegmentData = (0,useGoalEventProps/* default */.Z)({
        goalUID: goalUID
    });
    (0,react.useEffect)(function() {
        if (selectedMenu.label) segmentStorage/* default.setItem */.Z.setItem("lpss", selectedMenu.label);
        if (isGTP) (0,sidenav/* setSelectedNav */.Pg)(plusNavBarItems/* default.BROWSE */.Z.BROWSE);
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        selectedMenu.label,
        isGTP
    ]);
    var defaultBlockURL = blockInfo === null || blockInfo === void 0 ? void 0 : (ref2 = blockInfo.tabs) === null || ref2 === void 0 ? void 0 : (ref3 = ref2[0]) === null || ref3 === void 0 ? void 0 : ref3.url;
    if (!goalUID || !type || !blockInfo) return null;
    var isDropdownRequired = (blockInfo === null || blockInfo === void 0 ? void 0 : (ref4 = blockInfo.tabs) === null || ref4 === void 0 ? void 0 : ref4.length) > 1;
    var key = (0,feedTypeHelper/* getSeeAllFeedKey */.IZ)(isDropdownRequired, seeAllType, goalUID, type, selectedMenu.value);
    var handleButtonClick = function(option) {
        changeSelectedClassType(option);
        key = isDropdownRequired ? "".concat(type, "-").concat(option.value) : type;
        dispatch((0,specialClasses/* fetchSeeAllTypeFeed */.NM)(goalUID, key, option.url, blockId, seeAllType));
        if (isGTP) {
            analytics/* segment.track */.EX.track(segment/* FILTER_APPLIED */.pgu, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, goalSegmentData), {
                last_primary_source: segment/* FREE_CLASSES_AND_TESTS */.a_Z,
                filter_type: "Status",
                filter_value: option.label
            }));
        }
    };
    var menuItems = filterMenuItems(blockInfo.tabs);
    var label = isGTP && (0,feedTypeHelper/* isClassFeed */.wN)(blockInfo.entity_type) ? "Free Classes" : blockInfo.label;
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(emotion_react_jsx_runtime_browser_esm/* Fragment */.HY, {
        children: [
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(TopBlock/* default */.Z, {
                label: label,
                goal: goalInfo,
                seeAllType: seeAllType,
                isDropdown: isDropdownRequired,
                pageType: pageType
            }),
            isDropdownRequired && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(DropdownWrapper, {
                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Dropdown/* default */.Z, {
                    options: menuItems,
                    onOptionClick: handleButtonClick,
                    selectedOption: menuItems.find(function(menuItem) {
                        return menuItem.value === selectedMenu.value;
                    }),
                    gridColumn: "span 5",
                    menuWidth: "220px"
                })
            }),
            (0,feedTypeHelper/* isEducatorFeed */.iJ)(blockInfo.entity_type) && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(SeeAll_EducatorFeed, {
                goalSlug: goalSlug,
                goalUID: goalUID,
                educatorFeedBlock: classes,
                routerQuery: router.query,
                selectedMyClassType: selectedMenu.value,
                blockId: blockId,
                defaultBlockURL: defaultBlockURL,
                seeAllType: seeAllType,
                blockType: type,
                goalkey: key,
                useLeaderboardMetaInfo: useLeaderboardMetaInfo
            }),
            (0,feedTypeHelper/* isSubjectFeed */.iQ)(blockInfo.entity_type) && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(PopularSubjects/* default */.Z, {
                feedBlock: {
                    data: popularSubjects
                },
                isFeed: false
            }),
            ((0,feedTypeHelper/* isClassFeed */.wN)(blockInfo.entity_type) || (0,feedTypeHelper/* isBatchFeed */.Iw)(blockInfo.entity_type)) && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(ClassFeedBlock/* default */.Z, {
                classFeedBlock: classes,
                goalSlug: goalSlug,
                goalUID: goalUID,
                goalkey: key,
                blockId: blockId,
                defaultBlockURL: defaultBlockURL,
                seeAllType: seeAllType,
                blockType: type !== "my_classes" ? type : "".concat(type, "-").concat(selectedMenu === null || selectedMenu === void 0 ? void 0 : selectedMenu.value),
                dropdownOption: isDropdownRequired ? selectedMenu.value : "",
                label: selectedMenu.label
            }),
            (0,feedTypeHelper/* isTestSeriesFeed */.KT)(blockInfo.entity_type) && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(SeeAll_TestSeriesFeedBlock, {
                testSeriesFeedBlock: classes,
                goalSlug: goalSlug,
                goalUID: goalUID,
                goalkey: key,
                blockId: blockId,
                defaultBlockURL: defaultBlockURL,
                seeAllType: seeAllType,
                blockType: type,
                label: selectedMenu.label
            }),
            (0,feedTypeHelper/* isTopicFeed */.BK)(blockInfo.entity_type) && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(SeeAll_TopicFeedBlock, {
                testSeriesFeedBlock: classes,
                goalSlug: goalSlug,
                goalUID: goalUID,
                goalkey: key,
                blockId: blockId,
                defaultBlockURL: defaultBlockURL,
                seeAllType: seeAllType,
                blockType: type,
                onClick: function() {},
                label: selectedMenu.label
            })
        ]
    });
};
/* harmony default export */ var SeeAll_SeeAll = (SeeAll);
SeeAll.propTypes = {
    seeAllType: (prop_types_default()).string.isRequired,
    useLeaderboardMetaInfo: (prop_types_default()).bool
};
SeeAll.defaultProps = {
    useLeaderboardMetaInfo: false
};


/***/ }),

/***/ 92542:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(69396);
/* harmony import */ var _emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(35944);
/* harmony import */ var _Icon__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(55447);




var Check = function(props) {
    return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__/* .jsx */ .tZ)(_Icon__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)({}, props), {
        path: "M32.767 56.1c-0.003 0-0.008 0-0.012 0-0.687 0-1.308-0.28-1.755-0.733l-12.767-12.767c-0.416-0.445-0.671-1.045-0.671-1.704 0-1.381 1.119-2.5 2.5-2.5 0.659 0 1.259 0.255 1.706 0.672l-0.001-0.001 11 10.933 25.467-25.433c0.449-0.46 1.074-0.745 1.767-0.745s1.318 0.285 1.766 0.745l0 0.001c0.452 0.452 0.731 1.077 0.731 1.767s-0.279 1.314-0.731 1.767v0l-27.233 27.2c-0.434 0.49-1.064 0.798-1.766 0.8h-0z"
    }));
};
/* harmony default export */ __webpack_exports__["Z"] = (Check);


/***/ }),

/***/ 21572:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(69396);
/* harmony import */ var _emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(35944);
/* harmony import */ var _Icon__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(55447);




var KeyboardArrowDown = function(props) {
    return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__/* .jsx */ .tZ)(_Icon__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)({}, props), {
        path: "M39.8 52.033c-0.003 0-0.008 0-0.012 0-0.687 0-1.308-0.28-1.755-0.733l-20-20c-0.49-0.458-0.796-1.108-0.796-1.829 0-1.381 1.119-2.5 2.5-2.5 0.721 0 1.371 0.306 1.828 0.794l0.001 0.001 18.233 18.233 18.233-18.233c0.445-0.416 1.045-0.671 1.704-0.671 1.381 0 2.5 1.119 2.5 2.5 0 0.659-0.255 1.259-0.672 1.706l0.001-0.001-20 20c-0.447 0.453-1.068 0.733-1.755 0.733-0.004 0-0.008 0-0.012 0h0.001z"
    }));
};
/* harmony default export */ __webpack_exports__["default"] = (KeyboardArrowDown);


/***/ }),

/***/ 23018:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Hm": function() { return /* binding */ goBack; },
/* harmony export */   "Ox": function() { return /* binding */ getDoubtSolutionsHomeTags; },
/* harmony export */   "ZM": function() { return /* binding */ getFreeCourseTags; },
/* harmony export */   "fu": function() { return /* binding */ getCatalogueQuetionsHomeTag; },
/* harmony export */   "ll": function() { return /* binding */ getClass; },
/* harmony export */   "rs": function() { return /* binding */ getCatalogueDetailsHomeTags; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(26042);
/* harmony import */ var _models_Topology__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(34482);
/* harmony import */ var _models_Course__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(56046);
/* harmony import */ var _api_hooks_utils__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(61059);
/* harmony import */ var _textHelper__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(31309);

/* eslint-disable max-lines */ 



var getClass = function() {
    var item = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, isGTP = arguments.length > 1 ? arguments[1] : void 0;
    var ref;
    var _programme = item.programme, programme = _programme === void 0 ? {} : _programme;
    var goal = programme.goal, courseName = programme.name;
    if (!goal) return [];
    if (item.isSpecial || ((ref = item.programme) === null || ref === void 0 ? void 0 : ref.isSpecial)) {
        var tags = [
            {
                title: goal.name,
                as: (0,_models_Topology__WEBPACK_IMPORTED_MODULE_0__/* .getLink */ .Rg)(goal),
                href: (0,_models_Topology__WEBPACK_IMPORTED_MODULE_0__/* .getLinkHref */ .Hw)()
            }
        ];
        tags.push(isGTP ? (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({
            title: "Free Classes"
        }, (0,_models_Topology__WEBPACK_IMPORTED_MODULE_0__/* .getGtpFreeClassesAllLink */ .v9)(goal)) : {
            title: "Free classes & tests",
            as: (0,_models_Topology__WEBPACK_IMPORTED_MODULE_0__/* .getSpecialClassesLink */ .Lb)(goal),
            href: (0,_models_Topology__WEBPACK_IMPORTED_MODULE_0__/* .getSpecialClassesLinkHref */ .EN)()
        });
        return tags;
    }
    var tags1 = [
        {
            title: goal.name,
            as: (0,_models_Topology__WEBPACK_IMPORTED_MODULE_0__/* .getLink */ .Rg)(goal),
            href: (0,_models_Topology__WEBPACK_IMPORTED_MODULE_0__/* .getLinkHref */ .Hw)()
        }
    ];
    if (!isGTP) {
        tags1.push({
            title: courseName,
            as: (0,_models_Course__WEBPACK_IMPORTED_MODULE_1__/* .getLink */ .Rg)(programme),
            href: (0,_models_Course__WEBPACK_IMPORTED_MODULE_1__/* .getLinkPath */ .bc)(programme)
        });
    }
    return tags1;
};
var getDoubtSolutionsHomeTags = function(goal) {
    var // eslint-disable-next-line no-unused-vars
    ctlgData = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : null, // eslint-disable-next-line no-unused-vars
    ctlgItemData = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : null, isOfflineSubscription = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : null;
    if (!goal) return;
    var title = isOfflineSubscription ? "Centre" : "Plus";
    return [
        {
            title: goal.name,
            as: (0,_models_Topology__WEBPACK_IMPORTED_MODULE_0__/* .getLink */ .Rg)(goal),
            href: (0,_models_Topology__WEBPACK_IMPORTED_MODULE_0__/* .getLinkHref */ .Hw)()
        },
        {
            title: title,
            as: (0,_models_Topology__WEBPACK_IMPORTED_MODULE_0__/* .getLink */ .Rg)(goal),
            href: (0,_models_Topology__WEBPACK_IMPORTED_MODULE_0__/* .getLinkHref */ .Hw)()
        }
    ];
};
var getCatalogueQuetionsHomeTag = function(goal, ctlgData) {
    var // eslint-disable-next-line no-unused-vars
    ctlgItemData = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : null, isOfflineSubscription = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : null;
    if (!goal) return;
    var ctlgSlug = ctlgData.ctlgSlug, ctlgUID = ctlgData.ctlgUID, ctlgTitle = ctlgData.ctlgTitle;
    var title = isOfflineSubscription ? "Centre" : "Plus";
    return [
        {
            title: goal.name,
            as: (0,_models_Topology__WEBPACK_IMPORTED_MODULE_0__/* .getLink */ .Rg)(goal),
            href: (0,_models_Topology__WEBPACK_IMPORTED_MODULE_0__/* .getLinkHref */ .Hw)()
        },
        {
            title: title,
            as: (0,_models_Topology__WEBPACK_IMPORTED_MODULE_0__/* .getLink */ .Rg)(goal),
            href: (0,_models_Topology__WEBPACK_IMPORTED_MODULE_0__/* .getLinkHref */ .Hw)()
        },
        {
            title: "Doubt Solving",
            as: "".concat((0,_models_Topology__WEBPACK_IMPORTED_MODULE_0__/* .getLink */ .Rg)(goal), "/doubts-and-solutions/"),
            href: "".concat((0,_models_Topology__WEBPACK_IMPORTED_MODULE_0__/* .getLinkHref */ .Hw)(), "/doubts-and-solutions/")
        },
        {
            title: ctlgTitle,
            as: "".concat((0,_models_Topology__WEBPACK_IMPORTED_MODULE_0__/* .getLink */ .Rg)(goal), "/doubts-and-solutions/").concat(ctlgSlug, "/").concat(ctlgUID),
            href: "".concat((0,_models_Topology__WEBPACK_IMPORTED_MODULE_0__/* .getLinkHref */ .Hw)(), "/doubts-and-solutions/[catalogSlug]/[catalogUID]")
        }
    ];
};
var getCatalogueDetailsHomeTags = function(goal) {
    var // eslint-disable-next-line no-unused-vars
    ctlgData = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : null, // eslint-disable-next-line no-unused-vars
    ctlgItemData = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : null, isOfflineSubscription = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : null;
    if (!goal) return;
    var title = isOfflineSubscription ? "Centre" : "Plus";
    return [
        {
            title: goal.name,
            as: (0,_models_Topology__WEBPACK_IMPORTED_MODULE_0__/* .getLink */ .Rg)(goal),
            href: (0,_models_Topology__WEBPACK_IMPORTED_MODULE_0__/* .getLinkHref */ .Hw)()
        },
        {
            title: title,
            as: (0,_models_Topology__WEBPACK_IMPORTED_MODULE_0__/* .getLink */ .Rg)(goal),
            href: (0,_models_Topology__WEBPACK_IMPORTED_MODULE_0__/* .getLinkHref */ .Hw)()
        },
        {
            title: "Doubts & solutions",
            as: "".concat((0,_models_Topology__WEBPACK_IMPORTED_MODULE_0__/* .getLink */ .Rg)(goal), "/doubts-and-solutions/"),
            href: "".concat((0,_models_Topology__WEBPACK_IMPORTED_MODULE_0__/* .getLinkHref */ .Hw)(), "/doubts-and-solutions/")
        }
    ];
};
var getPlusTopicsTags = function(goal) {
    var isOfflineSubscription = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : null;
    if (!goal) return;
    var title = isOfflineSubscription ? "Centre" : "Plus";
    return [
        {
            title: goal.name,
            as: (0,_models_Topology__WEBPACK_IMPORTED_MODULE_0__/* .getLink */ .Rg)(goal),
            href: (0,_models_Topology__WEBPACK_IMPORTED_MODULE_0__/* .getLinkHref */ .Hw)()
        },
        {
            title: title,
            as: (0,_models_Topology__WEBPACK_IMPORTED_MODULE_0__/* .getLink */ .Rg)(goal),
            href: (0,_models_Topology__WEBPACK_IMPORTED_MODULE_0__/* .getLinkHref */ .Hw)()
        }
    ];
};
var getPlatformBatchTopicsTags = function(goal) {
    if (!goal) return [];
    return [
        {
            title: goal.name,
            as: (0,_models_Topology__WEBPACK_IMPORTED_MODULE_0__/* .getLink */ .Rg)(goal),
            href: (0,_models_Topology__WEBPACK_IMPORTED_MODULE_0__/* .getLinkHref */ .Hw)()
        }
    ];
};
var getBatchTags = function(goal) {
    var isOfflineSubscription = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : null, isStoreRoute = arguments.length > 2 ? arguments[2] : void 0;
    if (!goal) return;
    var title = isOfflineSubscription ? "Centre" : "Plus";
    var as = (0,_models_Topology__WEBPACK_IMPORTED_MODULE_0__/* .getLink */ .Rg)(goal);
    var href = (0,_models_Topology__WEBPACK_IMPORTED_MODULE_0__/* .getLinkHref */ .Hw)();
    return isStoreRoute ? [
        {
            title: goal.name,
            as: "".concat(as, "/store"),
            href: "".concat(href, "/store")
        },
        {
            title: "Batches",
            as: "".concat(as, "/store"),
            href: "".concat(href, "/store")
        }
    ] : [
        {
            title: goal.name,
            as: as,
            href: href
        },
        {
            title: title,
            as: as,
            href: href
        },
        {
            title: "Batches",
            as: "".concat(as, "/batches"),
            href: "".concat(href, "/batches")
        }
    ];
};
var getYoutubeLessonTags = function(goal, data) {
    if (!goal) return;
    return [
        (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({
            title: goal.name
        }, (0,_models_Topology__WEBPACK_IMPORTED_MODULE_0__/* .getYoutubeCourseLink */ .bU)(data)),
        (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({
            title: "Free courses"
        }, (0,_models_Topology__WEBPACK_IMPORTED_MODULE_0__/* .getYoutubeCourseLink */ .bU)(data)),
        (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({
            title: data.playlistName
        }, (0,_models_Topology__WEBPACK_IMPORTED_MODULE_0__/* .getYoutubeLessonLink */ ._Y)(data))
    ];
};
var getYoutubeCourseTags = function(goal) {
    if (!goal) return;
    return [
        {
            title: goal.name,
            as: "".concat((0,_models_Topology__WEBPACK_IMPORTED_MODULE_0__/* .getLink */ .Rg)(goal)),
            href: "".concat((0,_models_Topology__WEBPACK_IMPORTED_MODULE_0__/* .getLinkHref */ .Hw)())
        },
        (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({
            title: "Free courses"
        }, (0,_models_Topology__WEBPACK_IMPORTED_MODULE_0__/* .getYoutubeCourseLink */ .bU)({
            goalUID: goal.uid
        }))
    ];
};
var getGoalAndFreeTagsOfFreeTopic = function(goal) {
    if (!goal) return;
    return [
        {
            title: goal.name,
            as: (0,_models_Topology__WEBPACK_IMPORTED_MODULE_0__/* .getLink */ .Rg)(goal),
            href: (0,_models_Topology__WEBPACK_IMPORTED_MODULE_0__/* .getLinkHref */ .Hw)()
        },
        {
            title: "Free courses",
            as: "".concat((0,_models_Topology__WEBPACK_IMPORTED_MODULE_0__/* .getLink */ .Rg)(goal), "/free-platform"),
            href: "".concat((0,_models_Topology__WEBPACK_IMPORTED_MODULE_0__/* .getLinkHref */ .Hw)(), "/free-platform")
        }
    ];
};
var getGoalTopicsTitle = function(goal, isGTP) {
    if (goal.isNoTestGoal) return "Key concepts";
    if (isGTP) return "Video lessons";
    return "Syllabus";
};
var getTopics = function(goal) {
    var isGTP = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false;
    if (!goal) return;
    return [
        {
            // eslint-disable-next-line no-nested-ternary
            title: getGoalTopicsTitle(goal, isGTP),
            as: "".concat((0,_models_Topology__WEBPACK_IMPORTED_MODULE_0__/* .getLink */ .Rg)(goal), "/topics"),
            href: "".concat((0,_models_Topology__WEBPACK_IMPORTED_MODULE_0__/* .getLinkHref */ .Hw)(), "/topics")
        }
    ];
};
var getTopologyTags = function(topology, goal) {
    if (!topology || !goal) return;
    return [
        {
            title: topology.name,
            as: (0,_models_Topology__WEBPACK_IMPORTED_MODULE_0__/* .getTopicLink */ .pA)(topology, goal),
            href: (0,_models_Topology__WEBPACK_IMPORTED_MODULE_0__/* .getTopicLinkHref */ .BR)()
        }
    ];
};
var getEducatorTag = function(author, educatorUsername) {
    if (!author) return;
    return [
        {
            title: (0,_api_hooks_utils__WEBPACK_IMPORTED_MODULE_2__/* .getFullName */ .P)(author.firstName, author.lastName),
            as: "/@".concat(educatorUsername),
            href: "/[authorID]"
        }
    ];
};
var getCourseTags = function(goal, topicGroup) {
    var isOfflineSubscription = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : null;
    if (!goal) return [];
    var title = isOfflineSubscription ? "Centre" : "Plus";
    var Tags = [
        {
            title: goal.name,
            as: (0,_models_Topology__WEBPACK_IMPORTED_MODULE_0__/* .getLink */ .Rg)(goal),
            href: (0,_models_Topology__WEBPACK_IMPORTED_MODULE_0__/* .getLinkHref */ .Hw)()
        },
        {
            title: title,
            as: (0,_models_Topology__WEBPACK_IMPORTED_MODULE_0__/* .getLink */ .Rg)(goal),
            href: (0,_models_Topology__WEBPACK_IMPORTED_MODULE_0__/* .getLinkHref */ .Hw)()
        }
    ];
    if (topicGroup) {
        Tags.push({
            title: "Syllabus",
            as: (0,_models_Topology__WEBPACK_IMPORTED_MODULE_0__/* .getTopicListLink */ .dF)(goal),
            href: (0,_models_Topology__WEBPACK_IMPORTED_MODULE_0__/* .getTopicListHref */ .s3)()
        }, {
            title: topicGroup.name,
            as: (0,_models_Topology__WEBPACK_IMPORTED_MODULE_0__/* .getTopicLink */ .pA)(topicGroup, goal),
            href: (0,_models_Topology__WEBPACK_IMPORTED_MODULE_0__/* .getLinkPath */ .bc)()
        });
    }
    return Tags;
};
var getFreeCourseTags = function(goal, topologies) {
    var ref;
    if (!(goal === null || goal === void 0 ? void 0 : goal.uid)) return [];
    var ref1 = (0,_models_Topology__WEBPACK_IMPORTED_MODULE_0__/* .getHrefAndAsOfAFreeCourse */ .Ho)(goal), href = ref1.href, as = ref1.as;
    var Tags = [
        {
            title: goal.name,
            href: href,
            as: as
        },
        {
            title: "Free courses",
            href: href,
            as: as
        }
    ];
    if (topologies === null || topologies === void 0 ? void 0 : (ref = topologies.parent) === null || ref === void 0 ? void 0 : ref.parent) {
        Tags.push({
            title: topologies.parent.parent.name,
            as: "/goal/".concat(goal.goalSlug, "/").concat(goal.uid, "/free-platform/").concat(topologies.parent.parent.slug || (0,_textHelper__WEBPACK_IMPORTED_MODULE_3__/* .getStringWordsJoinedWith */ .kL)(topologies.parent.parent.name, "-"), "/").concat(topologies.parent.parent.uid),
            href: "/goal/[goalSlug]/[goalUID]/free-platform/[topicSlugType]/[topicSlugUID] "
        });
        Tags.push({
            title: topologies.parent.name,
            as: "/goal/".concat(goal.goalSlug, "/").concat(goal.uid, "/free-platform/").concat(topologies.parent.parent.slug || (0,_textHelper__WEBPACK_IMPORTED_MODULE_3__/* .getStringWordsJoinedWith */ .kL)(topologies.parent.parent.name, "-"), "/").concat(topologies.parent.slug || (0,_textHelper__WEBPACK_IMPORTED_MODULE_3__/* .getStringWordsJoinedWith */ .kL)(topologies.parent.name, "-"), "/").concat(topologies.parent.uid),
            href: "/goal/[goalSlug]/[goalUID]/free-platform/[topicSlugType]/[topicSlugUID]/[conceptUID] "
        });
    }
    return Tags;
};
var getTestSeriesTags = function(goal) {
    var isOfflineSubscription = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : null;
    if (!goal) return [];
    var title = isOfflineSubscription ? "Centre" : "Plus";
    return [
        {
            title: goal.name,
            as: (0,_models_Topology__WEBPACK_IMPORTED_MODULE_0__/* .getLink */ .Rg)(goal),
            href: (0,_models_Topology__WEBPACK_IMPORTED_MODULE_0__/* .getLinkHref */ .Hw)()
        },
        {
            title: title,
            as: (0,_models_Topology__WEBPACK_IMPORTED_MODULE_0__/* .getLink */ .Rg)(goal),
            href: (0,_models_Topology__WEBPACK_IMPORTED_MODULE_0__/* .getLinkHref */ .Hw)()
        },
        {
            title: "Test series",
            href: "/goal/[goalSlug]/[goalUID]/test-series",
            as: "/goal/".concat(goal.slug, "/").concat(goal.uid, "/test-series")
        }
    ];
};
var getPlatformSeeAllTags = function(seeAllType, goal, topicGroup) {
    var hasSubscription = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : true, pageType = arguments.length > 4 ? arguments[4] : void 0, isOfflineSubscription = arguments.length > 5 && arguments[5] !== void 0 ? arguments[5] : null;
    var seeAllLinks = null;
    var title = isOfflineSubscription ? "Centre" : "Plus";
    if (seeAllType === "specialClass") {
        seeAllLinks = [
            {
                title: goal.name,
                as: (0,_models_Topology__WEBPACK_IMPORTED_MODULE_0__/* .getLink */ .Rg)(goal),
                href: (0,_models_Topology__WEBPACK_IMPORTED_MODULE_0__/* .getLinkHref */ .Hw)(goal)
            },
            (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({
                title: "Free classes & tests"
            }, (0,_models_Topology__WEBPACK_IMPORTED_MODULE_0__/* .getSpecialClassesAllLink */ .Po)(goal))
        ];
        return seeAllLinks;
    }
    if (seeAllType === "goal" && !hasSubscription) {
        if ([
            "educators",
            "batches",
            "upcoming",
            "recently_started",
            "popular_courses"
        ].includes(pageType)) {
            seeAllLinks = [
                {
                    title: goal.name,
                    as: (0,_models_Topology__WEBPACK_IMPORTED_MODULE_0__/* .getLink */ .Rg)(goal),
                    href: (0,_models_Topology__WEBPACK_IMPORTED_MODULE_0__/* .getLinkHref */ .Hw)(goal)
                }
            ];
            return seeAllLinks;
        }
    }
    if (seeAllType === "goal" || seeAllType === "enrolled") {
        seeAllLinks = [
            (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({
                title: goal.name
            }, (0,_models_Topology__WEBPACK_IMPORTED_MODULE_0__/* .getBrowseLink */ .UP)(goal)),
            (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({
                title: title
            }, (0,_models_Topology__WEBPACK_IMPORTED_MODULE_0__/* .getBrowseLink */ .UP)(goal))
        ];
        return seeAllLinks;
    }
    if (seeAllType === "freeCourses") {
        seeAllLinks = [
            {
                title: goal.name,
                as: (0,_models_Topology__WEBPACK_IMPORTED_MODULE_0__/* .getLink */ .Rg)(goal),
                href: (0,_models_Topology__WEBPACK_IMPORTED_MODULE_0__/* .getLinkHref */ .Hw)(goal)
            },
            (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({
                title: "Free"
            }, (0,_models_Topology__WEBPACK_IMPORTED_MODULE_0__/* .getHrefAndAsOfAFreeCourse */ .Ho)(goal))
        ];
        return seeAllLinks;
    }
    return [
        {
            title: goal.name
        },
        {
            title: title
        },
        {
            title: "Syllabus",
            as: (0,_models_Topology__WEBPACK_IMPORTED_MODULE_0__/* .getTopicListLink */ .dF)(goal),
            href: (0,_models_Topology__WEBPACK_IMPORTED_MODULE_0__/* .getTopicListHref */ .s3)()
        },
        {
            title: topicGroup.name,
            href: (0,_models_Topology__WEBPACK_IMPORTED_MODULE_0__/* .getTopicLink */ .pA)(topicGroup, goal),
            as: (0,_models_Topology__WEBPACK_IMPORTED_MODULE_0__/* .getLinkPath */ .bc)()
        }
    ];
};
var getSeeAllTags = function(seeAllType, goal, topicGroup) {
    var hasSubscription = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : true, pageType = arguments.length > 4 ? arguments[4] : void 0, isGTP = arguments.length > 5 ? arguments[5] : void 0, isOfflineSubscription = arguments.length > 6 ? arguments[6] : void 0;
    var title = isOfflineSubscription ? "Centre" : "Plus";
    var seeAllLinks = null;
    if (seeAllType === "enrolledBatches") {
        seeAllLinks = [
            (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({
                title: goal.name
            }, (0,_models_Topology__WEBPACK_IMPORTED_MODULE_0__/* .getPannerLink */ .vx)(goal))
        ];
        return seeAllLinks;
    }
    if (seeAllType === "specialClass") {
        seeAllLinks = [
            {
                title: goal.name,
                as: (0,_models_Topology__WEBPACK_IMPORTED_MODULE_0__/* .getLink */ .Rg)(goal),
                href: (0,_models_Topology__WEBPACK_IMPORTED_MODULE_0__/* .getLinkHref */ .Hw)(goal)
            }
        ];
        seeAllLinks.push(isGTP ? (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({
            title: "Free Classes"
        }, (0,_models_Topology__WEBPACK_IMPORTED_MODULE_0__/* .getGtpFreeClassesAllLink */ .v9)(goal)) : (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({
            title: "Free classes & tests"
        }, (0,_models_Topology__WEBPACK_IMPORTED_MODULE_0__/* .getSpecialClassesAllLink */ .Po)(goal)));
        return seeAllLinks;
    }
    if (seeAllType === "goal" && !hasSubscription) {
        if ([
            "educators",
            "batches",
            "upcoming",
            "recently_started",
            "popular_courses"
        ].includes(pageType)) {
            seeAllLinks = [
                {
                    title: goal.name,
                    as: (0,_models_Topology__WEBPACK_IMPORTED_MODULE_0__/* .getLink */ .Rg)(goal),
                    href: (0,_models_Topology__WEBPACK_IMPORTED_MODULE_0__/* .getLinkHref */ .Hw)(goal)
                },
                {
                    title: "Browse",
                    as: "".concat((0,_models_Topology__WEBPACK_IMPORTED_MODULE_0__/* .getLink */ .Rg)(goal), "/browse"),
                    href: "".concat((0,_models_Topology__WEBPACK_IMPORTED_MODULE_0__/* .getLinkHref */ .Hw)(goal), "/browse")
                }
            ];
            return seeAllLinks;
        }
    }
    if (seeAllType === "goal" || seeAllType === "enrolled") {
        seeAllLinks = [
            (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({
                title: (goal === null || goal === void 0 ? void 0 : goal.name) || ""
            }, (0,_models_Topology__WEBPACK_IMPORTED_MODULE_0__/* .getBrowseLink */ .UP)(goal)),
            (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({
                title: title
            }, (0,_models_Topology__WEBPACK_IMPORTED_MODULE_0__/* .getBrowseLink */ .UP)(goal))
        ];
        return seeAllLinks;
    }
    if (seeAllType === "freeCourses") {
        seeAllLinks = [
            {
                title: (goal === null || goal === void 0 ? void 0 : goal.name) || "",
                as: (0,_models_Topology__WEBPACK_IMPORTED_MODULE_0__/* .getLink */ .Rg)(goal),
                href: (0,_models_Topology__WEBPACK_IMPORTED_MODULE_0__/* .getLinkHref */ .Hw)(goal)
            },
            (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({
                title: "Free"
            }, (0,_models_Topology__WEBPACK_IMPORTED_MODULE_0__/* .getHrefAndAsOfAFreeCourse */ .Ho)(goal))
        ];
        return seeAllLinks;
    }
    if (seeAllType === "enrolledCourses") {
        seeAllLinks = [
            (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({
                title: (goal === null || goal === void 0 ? void 0 : goal.name) || ""
            }, (0,_models_Topology__WEBPACK_IMPORTED_MODULE_0__/* .getBrowseLink */ .UP)(goal)),
            (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({
                title: title
            }, (0,_models_Topology__WEBPACK_IMPORTED_MODULE_0__/* .getBrowseLink */ .UP)(goal)),
            {
                title: "Enrolled",
                href: "".concat((0,_models_Topology__WEBPACK_IMPORTED_MODULE_0__/* .getLinkHref */ .Hw)(), "/enrolled"),
                as: "".concat((0,_models_Topology__WEBPACK_IMPORTED_MODULE_0__/* .getLink */ .Rg)(goal), "/enrolled")
            }
        ];
        return seeAllLinks;
    }
    return [
        (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({
            title: (goal === null || goal === void 0 ? void 0 : goal.name) || ""
        }, (0,_models_Topology__WEBPACK_IMPORTED_MODULE_0__/* .getBrowseLink */ .UP)(goal)),
        (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({
            title: title
        }, (0,_models_Topology__WEBPACK_IMPORTED_MODULE_0__/* .getBrowseLink */ .UP)(goal)),
        {
            title: "Syllabus",
            as: (0,_models_Topology__WEBPACK_IMPORTED_MODULE_0__/* .getTopicListLink */ .dF)(goal),
            href: (0,_models_Topology__WEBPACK_IMPORTED_MODULE_0__/* .getTopicListHref */ .s3)()
        },
        {
            title: topicGroup.name,
            href: (0,_models_Topology__WEBPACK_IMPORTED_MODULE_0__/* .getTopicLink */ .pA)(topicGroup, goal),
            as: (0,_models_Topology__WEBPACK_IMPORTED_MODULE_0__/* .getLinkPath */ .bc)()
        }
    ];
};
var getSavedTag = function(goal) {
    if (!goal) return [];
    return [
        (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({
            title: "Saved"
        }, (0,_models_Topology__WEBPACK_IMPORTED_MODULE_0__/* .getHrefAndAsOfSaved */ .vX)(goal))
    ];
};
var goBack = function() {
    return window.history.back();
};
var getDriveTags = function(ancestors) {
    if (!ancestors || !Array.isArray(ancestors)) return [];
    return ancestors.map(function(item) {
        var isRoot = (item === null || item === void 0 ? void 0 : item.name) === "root";
        return {
            title: isRoot ? "Cloud" : item === null || item === void 0 ? void 0 : item.name,
            as: isRoot ? "/educator/drive" : "/educator/drive/folder/".concat(item === null || item === void 0 ? void 0 : item.uid),
            href: isRoot ? "/educator/drive" : "/educator/drive/folder/[itemUID]"
        };
    });
};
var getFreeLiveClassesTags = function(goal) {
    if (!goal) return;
    var as = (0,_models_Topology__WEBPACK_IMPORTED_MODULE_0__/* .getLink */ .Rg)(goal);
    var href = (0,_models_Topology__WEBPACK_IMPORTED_MODULE_0__/* .getLinkHref */ .Hw)();
    return [
        {
            title: goal.name,
            as: as,
            href: href
        },
        {
            title: "Free live classes",
            as: "".concat(as, "/classes"),
            href: "".concat(href, "/classes")
        }
    ];
};
var breadcrumbs = {
    getClass: getClass,
    goBack: goBack,
    getPlusTopicsTags: getPlusTopicsTags,
    getTopologyTags: getTopologyTags,
    getTopics: getTopics,
    getCourseTags: getCourseTags,
    getTestSeriesTags: getTestSeriesTags,
    getSeeAllTags: getSeeAllTags,
    getFreeCourseTags: getFreeCourseTags,
    getGoalAndFreeTagsOfFreeTopic: getGoalAndFreeTagsOfFreeTopic,
    getBatchTags: getBatchTags,
    getSavedTag: getSavedTag,
    getDriveTags: getDriveTags,
    getDoubtSolutionsHomeTags: getDoubtSolutionsHomeTags,
    getCatalogueQuetionsHomeTag: getCatalogueQuetionsHomeTag,
    getCatalogueDetailsHomeTags: getCatalogueDetailsHomeTags,
    getPlatformSeeAllTags: getPlatformSeeAllTags,
    getPlatformBatchTopicsTags: getPlatformBatchTopicsTags,
    getEducatorTag: getEducatorTag,
    getYoutubeLessonTags: getYoutubeLessonTags,
    getYoutubeCourseTags: getYoutubeCourseTags,
    getFreeLiveClassesTags: getFreeLiveClassesTags
};
/* harmony default export */ __webpack_exports__["ZP"] = (breadcrumbs);


/***/ })

}]);